var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuropaRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Thu Oct  3 04:02:58 2013\n By ,,,\nCopyright (c) 2011 Fabian Leuenberger and EuropaType. All rights reserved. This Font Software may not be reproduced, modified, disclosed or transferred without the express written approval of EuropaType. EUROPA is a trademark of EuropaType and may be registered in certain jurisdictions. This Font Software is original artwork of Fabian Leuenberger and EuropaType. The design may be protected in certain jurisdictions.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Europa-Regular",
    horizAdvX: 580
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Europa-Regular",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 0 0 0 0 0 0 0 0 0",
    ascent: 782,
    descent: -218,
    xHeight: 462,
    capHeight: 700,
    bbox: "-194 -254 1048 991",
    underlineThickness: 38,
    underlinePosition: -153,
    unicodeRange: "U+0020-FB04"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 570,
    d: "M314 181q0 -12 -8.5 -21t-20.5 -9q-13 0 -22 9t-9 21t9 21t22 9q12 0 20.5 -9t8.5 -21zM348 436q0 25 -18.5 43t-45.5 18q-24 0 -43 -13.5t-25 -27.5l-7 -14l-38 19q1 3 3 8.5t11.5 19t21 23.5t32 18.5t45.5 8.5q44 0 76 -30t32 -73q0 -23 -11 -44.5t-20 -31t-26 -24.5 q-22 -18 -26 -25.5t-4 -24.5v-33h-42v33q0 27 6.5 40t32.5 35q2 2 12 11t13.5 13t9.5 12.5t8.5 18t2.5 20.5zM40 0v700h490v-700h-490zM80 663v-626h410v626h-410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffj",
    unicode: "ffj",
    horizAdvX: 799,
    d: "M515 -221l30 70q23 -13 35 -13q15 0 25 3.5t19 20.5t9 47v555h84v-563q0 -74 -38.5 -107.5t-85.5 -33.5q-42 0 -78 21zM298 462v-76h-100v-386h-84v386h-94v76h94v134q0 73 48 122.5t124 49.5q79 0 130 -56q49 56 128 56q76 0 124.5 -49.5t48.5 -122.5v-10 q0 -17 -12.5 -29.5t-29.5 -12.5t-29.5 12.5t-12.5 29.5v14q0 35 -22.5 62.5t-66.5 27.5q-43 0 -64 -26t-22 -61v-3v-138h100v-76h-100v-386h-84v596v4q0 35 -22 62.5t-66 27.5t-66 -27.5t-22 -62.5v-138h100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fft",
    unicode: "fft",
    horizAdvX: 923,
    d: "M198 616v-154h190v159q0 69 43.5 108t98.5 39q48 0 97 -27l-31 -69q-28 18 -54 18q-33 0 -51.5 -20t-18.5 -54v-154h190v141h84v-141h144v-76h-144v-246q0 -35 17 -54.5t50 -19.5q12 0 25 5t20 9l8 5l31 -69q-51 -28 -96 -28q-55 0 -97 39t-42 108v251h-190v-386h-84v386 h-190v-386h-84v386h-94v76h94v159q0 69 43.5 108t98.5 39q48 0 97 -27l-31 -69q-28 18 -54 18q-33 0 -51.5 -20t-18.5 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ff",
    unicode: "ff",
    horizAdvX: 607,
    d: "M190 616v-154h190v159q0 69 43.5 108t98.5 39q48 0 97 -27l-31 -69q-28 18 -54 18q-33 0 -51.5 -20t-18.5 -54v-154h120v-76h-120v-386h-84v386h-190v-386h-84v386h-86v76h86v159q0 69 43.5 108t98.5 39q48 0 97 -27l-31 -69q-28 18 -54 18q-33 0 -51.5 -20t-18.5 -54z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 538,
    d: "M372 586v14q0 35 -22 62.5t-65 27.5t-65 -27.5t-22 -62.5v-138h103v-76h-103v-386h-84v386h-94v76h94v134q0 73 47.5 122.5t123.5 49.5t123.5 -49.5t47.5 -122.5v-10q0 -17 -12.5 -29.5t-29.5 -12.5t-29.5 12.5t-12.5 29.5zM372 0v462h84v-462h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 538,
    d: "M372 0v600q0 35 -22 62.5t-65 27.5t-65 -27.5t-22 -62.5v-138h103v-76h-103v-386h-84v386h-94v76h94v134q0 73 47.5 122.5t123.5 49.5t123.5 -49.5t47.5 -122.5v-596h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffi",
    unicode: "ffi",
    horizAdvX: 798,
    d: "M632 0v462h84v-462h-84zM299 462v-76h-101v-386h-84v386h-94v76h94v134q0 73 48 122.5t124 49.5q79 0 130 -56q49 56 129 56q76 0 123.5 -49.5t47.5 -122.5v-10q0 -17 -12.5 -29.5t-29.5 -12.5t-29.5 12.5t-12.5 29.5v14q0 35 -22 62.5t-65 27.5t-64.5 -26t-22.5 -61v-3 v-138h103v-76h-103v-386h-84v596v4q0 35 -22 62.5t-66 27.5t-66 -27.5t-22 -62.5v-138h101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffl",
    unicode: "ffl",
    horizAdvX: 798,
    d: "M298 462v-76h-100v-386h-84v386h-94v76h94v134q0 73 48 122.5t124 49.5q79 0 130 -56q49 56 129 56q76 0 123.5 -49.5t47.5 -122.5v-596h-84v600q0 35 -22 62.5t-65 27.5t-65 -27.5t-22 -62.5v-4v-134h100v-76h-100v-386h-84v596v7q-1 34 -23.5 60.5t-64.5 26.5 q-44 0 -66 -27.5t-22 -62.5v-138h100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 570,
    d: "M314 181q0 -12 -8.5 -21t-20.5 -9q-13 0 -22 9t-9 21t9 21t22 9q12 0 20.5 -9t8.5 -21zM348 436q0 25 -18.5 43t-45.5 18q-24 0 -43 -13.5t-25 -27.5l-7 -14l-38 19q1 3 3 8.5t11.5 19t21 23.5t32 18.5t45.5 8.5q44 0 76 -30t32 -73q0 -23 -11 -44.5t-20 -31t-26 -24.5 q-22 -18 -26 -25.5t-4 -24.5v-33h-42v33q0 27 6.5 40t32.5 35q2 2 12 11t13.5 13t9.5 12.5t8.5 18t2.5 20.5zM40 0v700h490v-700h-490zM80 663v-626h410v626h-410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 280
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 277,
    d: "M181 700v-519h-84v519h84zM195 45q0 -23 -17 -40t-39 -17q-23 0 -40 17t-17 40q0 22 17 39t40 17t39.5 -16.5t16.5 -39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 332,
    d: "M60 462v238h72v-238h-72zM200 462v238h72v-238h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 634,
    d: "M77 430v64h128l32 222l61 -9l-30 -213h136l31 222l62 -9l-30 -213h119v-64h-128l-21 -144h120v-64h-129l-33 -237l-61 9l32 228h-136l-33 -237l-62 9l32 228h-119v64h128l20 144h-119zM259 430l-20 -144h136l20 144h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    d: "M276 -94v83q-43 3 -80 18.5t-59 36.5t-37.5 41.5t-21.5 34.5l-7 14l70 43q2 -4 5 -10.5t14.5 -24t26 -31t38.5 -26.5t51 -16v251q-43 20 -70 36t-54.5 41t-41 57.5t-13.5 73.5q0 64 48 119.5t131 63.5v83h51v-84q50 -6 92.5 -31t60.5 -47l17 -22l-63 -52q-4 6 -12.5 16 t-36 29.5t-58.5 25.5v-240q3 -2 9 -4q45 -21 73 -38t53 -41t36.5 -55.5t11.5 -72.5q0 -76 -51 -127.5t-132 -60.5v-84h-51zM424 178q0 42 -24.5 68t-72.5 50v-225q42 9 69.5 36.5t27.5 70.5zM181 528q0 -39 23 -64.5t72 -50.5v217q-44 -6 -69.5 -36t-25.5 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 712,
    d: "M189 712q65 0 111 -45t46 -110t-46 -110t-111 -45t-111 45t-46 110t46 110t111 45zM189 456q42 0 70.5 29.5t28.5 71.5t-28.5 71.5t-70.5 29.5t-70.5 -29.5t-28.5 -71.5t28.5 -71.5t70.5 -29.5zM96 11l461 709l43 -29l-459 -711zM523 298q65 0 111 -45t46 -110t-46 -110 t-111 -45t-111 45t-46 110t46 110t111 45zM523 42q42 0 70.5 29.5t28.5 71.5t-28.5 71.5t-70.5 29.5t-70.5 -29.5t-28.5 -71.5t28.5 -71.5t70.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 701,
    d: "M545 384h78q0 -69 -11 -125.5t-22 -78.5l-11 -22l122 -110l-51 -60l-120 106q-38 -47 -101.5 -76.5t-133.5 -29.5q-99 0 -161 49.5t-62 115.5q0 59 30 103t120 114q-59 53 -82 94t-23 88q0 62 48 111t128 49t128 -49.5t48 -110.5q0 -46 -24.5 -83t-100.5 -100l175 -158 q26 33 26 173zM295 66q52 0 101 21.5t78 57.5l-193 172l-3 -3q-70 -58 -96 -87.5t-26 -63.5q0 -49 41.5 -73t97.5 -24zM201 552q0 -23 9 -43t15.5 -28.5t31 -31t31.5 -29.5q68 59 82.5 78.5t14.5 53.5t-26.5 60t-65.5 26q-41 0 -66.5 -26.5t-25.5 -59.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 150,
    d: "M40 462v238h70v-238h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 308,
    d: "M280 -115l-61 -43q-79 119 -116 220.5t-37 232.5t37 232.5t116 220.5l61 -43q-71 -110 -103.5 -199t-32.5 -211t32.5 -211t103.5 -199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 308,
    d: "M89 -158l-61 43q71 110 103.5 199t32.5 211t-32.5 211t-103.5 199l61 43q79 -119 116 -220.5t37 -232.5t-37 -232.5t-116 -220.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 398,
    d: "M370 564l-122 -39l74 -104l-48 -34l-74 106l-76 -106l-48 35l76 103l-124 39l18 57l123 -41v132h60v-132l123 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 520,
    d: "M492 278v-74h-194v-204h-76v204h-194v74h194v196h76v-196h194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 229,
    d: "M24 -142l81 234l76 -26l-86 -233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 333,
    d: "M33 204v80h267v-80h-267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 230,
    d: "M58 45q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 497,
    d: "M487 764l-397 -897l-68 30l397 897z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 592,
    d: "M297 712q85 0 144 -52.5t84 -132t25 -177.5t-25 -177.5t-84 -132t-144 -52.5t-144.5 52.5t-85 132t-25.5 177.5t25.5 177.5t85 132t144.5 52.5zM297 66q59 0 98.5 44t55 105t15.5 135t-15.5 135t-55 105t-98.5 44t-99 -43.5t-56 -105.5t-16 -135t16 -135t56 -105.5 t99 -43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 405,
    d: "M18 547l192 153h75v-700h-84v590l-134 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 532,
    d: "M52 0l246 326l15 19q15 19 20.5 26.5t18 28t18.5 34.5t11.5 34.5t5.5 38.5q0 54 -33.5 90.5t-95.5 36.5q-49 0 -83.5 -27t-44.5 -53l-10 -27l-72 27q2 6 5.5 17t19.5 38t37.5 48t60.5 38t87 17q95 0 154 -58.5t59 -146.5q0 -19 -3 -38t-9 -35.5t-12 -30t-14.5 -27.5 t-13.5 -21l-12.5 -17.5t-8.5 -11.5l-186 -248h264v-78h-424z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 544,
    d: "M389 515q0 48 -35.5 83.5t-89.5 35.5q-44 0 -77 -23t-43 -45l-11 -23l-72 32q2 6 6.5 15t21 32.5t37.5 41.5t58 33t80 15q87 0 148 -57t61 -140q0 -32 -9 -59.5t-21.5 -43.5t-25 -28t-21.5 -16l-9 -5q4 -1 11 -3.5t25 -15t31.5 -29.5t24.5 -49.5t11 -72.5q0 -93 -65 -149 t-163 -56q-50 0 -92 16.5t-65.5 40t-40 46.5t-22.5 39l-5 17l74 34q1 -5 4 -12.5t14.5 -27.5t27 -35t43.5 -27.5t62 -12.5q65 0 104.5 37t39.5 90q0 60 -37.5 93t-110.5 33h-33v77h21q62 0 102.5 30.5t40.5 88.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 562,
    d: "M2 184l365 516h74v-438h87v-78h-87v-184h-82v184h-357zM142 262h217v310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 575,
    d: "M527 223q0 -111 -70 -173t-168 -62q-48 0 -89 15.5t-65.5 37.5t-42 44.5t-24.5 38.5l-6 15l73 39l5 -12.5t16 -26.5t29 -34t44 -27t60 -12q65 0 109.5 41.5t44.5 115.5q0 76 -44 116.5t-112 40.5q-43 0 -90.5 -19.5t-73.5 -38.5l-26 -20v398h415v-78h-335v-192 q51 29 129 29q92 0 156.5 -61.5t64.5 -174.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 542,
    d: "M374 680l-151 -240q21 10 50 10q105 0 167 -67.5t62 -161.5t-62 -163.5t-167 -69.5t-167 69.5t-62 161.5q0 61 34 124l228 381zM273 372q-64 0 -104.5 -44t-40.5 -107q0 -64 40 -109.5t105 -45.5t105 45.5t40 109.5q0 63 -40.5 107t-104.5 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 506,
    d: "M46 622v78h466l-372 -718l-71 38l311 602h-334z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 552,
    d: "M276 712q89 0 143 -57t54 -131q0 -43 -21.5 -83.5t-56.5 -61.5q48 -26 75.5 -73t27.5 -106q0 -88 -62 -150t-160 -62t-160 62t-62 150q0 59 27.5 106t75.5 73q-35 21 -56.5 61.5t-21.5 83.5q0 74 54 131t143 57zM276 66q61 0 99.5 40.5t38.5 93.5q0 57 -38 98t-100 41 t-100 -41t-38 -98q0 -53 38.5 -93.5t99.5 -40.5zM276 412q48 0 80.5 31.5t32.5 79.5t-32.5 79.5t-80.5 31.5t-80.5 -31.5t-32.5 -79.5t32.5 -79.5t80.5 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 542,
    d: "M169 23l151 241q-15 -12 -51 -12q-105 0 -167 68t-62 160t62 162t167 70t167 -70t62 -162q0 -51 -28 -109l-233 -392zM269 330q64 0 104.5 43.5t40.5 106.5q0 64 -40 109t-105 45t-105 -45t-40 -109q0 -63 40.5 -106.5t104.5 -43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 236,
    d: "M61 45q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM61 417q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 230,
    d: "M68 417q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM24 -142l81 234l76 -26l-86 -233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 520,
    d: "M18 236v70l462 197v-78l-366 -154l366 -155v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 520,
    d: "M55 283v74h410v-74h-410zM55 125v74h410v-74h-410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 520,
    d: "M502 306v-70l-462 -198v78l366 155l-366 154v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 482,
    d: "M353 519q0 47 -35 81t-85 34q-46 0 -80.5 -26t-46.5 -52l-12 -25l-72 34q2 6 6 16t21 35t38.5 44.5t60.5 35.5t85 16q84 0 144 -55.5t60 -137.5q0 -34 -9.5 -63.5t-28.5 -53.5t-33 -37.5t-36 -32.5q-41 -33 -48.5 -46.5t-7.5 -47.5v-58h-78v58q0 53 11.5 77t58.5 65 q4 4 15.5 13t16 13.5t14 13.5t14 15t11 16t9 19.5t5 22t2.5 26.5zM179 44q0 23 16.5 40t39.5 17t40 -17t17 -40t-17 -39.5t-40 -16.5t-39.5 16.5t-16.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 799,
    d: "M577 89l25 -54q-88 -47 -192 -47q-150 0 -256 106t-106 256t106 256t256 106q148 0 244.5 -101t96.5 -246q0 -67 -15 -113t-40 -66.5t-47 -28.5t-46 -8q-37 0 -66.5 17t-35.5 54l-5 -7.5t-14 -17t-24.5 -22t-35.5 -17t-46 -7.5q-51 0 -91.5 36t-40.5 93q0 55 41.5 90.5 t104.5 35.5q29 0 55 -12t38 -24l12 -12v30q0 54 -27.5 75.5t-64.5 21.5q-29 0 -55.5 -9.5t-39.5 -19.5l-12 -10l-29 53q7 5 19 13t47.5 21.5t70.5 13.5q73 0 114.5 -39t41.5 -106v-149q0 -43 46 -43q83 0 83 157q0 122 -78.5 203.5t-200.5 81.5q-124 0 -212 -88t-88 -212 t88 -212t212 -88q93 0 167 39zM390 209q22 0 41 6.5t30.5 16t19.5 19t11 15.5l3 7v30q-4 5 -11 12.5t-33 19.5t-55 12q-36 0 -60 -20t-24 -49q0 -34 22.5 -51.5t55.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 642,
    d: "M8 0l275 700h78l273 -700h-88l-73 189h-302l-73 -189h-90zM322 580l-120 -311h240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 563,
    d: "M82 0v700h184q107 0 166 -51t59 -140q0 -33 -10.5 -60.5t-25.5 -43t-26.5 -24t-16.5 -9.5q6 -1 16.5 -5t29 -16.5t33.5 -30t26.5 -49.5t11.5 -71q0 -91 -62 -145.5t-166 -54.5h-219zM301 80q71 0 107.5 33.5t36.5 86.5t-36.5 86.5t-107.5 33.5h-135v-240h135zM166 398 h114q59 0 93 30t34 81t-34 81t-93 30h-114v-222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 663,
    d: "M635 605l-58 -55q-3 3 -8 8.5t-23 20t-38.5 25t-54 19.5t-69.5 9q-111 0 -183.5 -83.5t-72.5 -198.5t72.5 -198.5t183.5 -83.5q36 0 69.5 9.5t56.5 23.5t41 27.5t27 23.5l8 9l57 -58q-4 -5 -11.5 -12.5t-32.5 -27.5t-53 -35t-72 -27.5t-90 -12.5q-150 0 -248 104.5 t-98 257.5t98 257.5t248 104.5q73 0 135.5 -27t88.5 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 667,
    d: "M283 700q160 0 253 -97.5t93 -252.5t-93 -252.5t-253 -97.5h-201v700h201zM278 80q124 0 192.5 76.5t68.5 193.5t-68.5 193.5t-192.5 76.5h-112v-540h112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 544,
    d: "M166 620v-221h296v-80h-296v-239h326v-80h-410v700h404v-80h-320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 523,
    d: "M166 620v-221h291v-80h-291v-319h-84v700h395v-80h-311z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 717,
    d: "M403 304v80h258v-304q-4 -4 -11 -10t-33 -22t-55.5 -28t-77 -22t-98.5 -10q-150 0 -249 104.5t-99 257.5t99 257.5t249 104.5q51 0 96 -10t73 -25t48.5 -29.5t29.5 -24.5l9 -10l-60 -59q-3 3 -8 8.5t-23.5 19t-39.5 23.5t-55 18.5t-70 8.5q-111 0 -184.5 -83.5 t-73.5 -198.5t73.5 -198.5t184.5 -83.5q57 0 105 13t67 25l20 13v185h-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 683,
    d: "M517 399v301h84v-700h-84v319h-351v-319h-84v700h84v-301h351z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 276,
    d: "M96 0v700h84v-700h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 474,
    d: "M308 186v514h84v-513q0 -89 -55.5 -144t-150.5 -55q-32 0 -63 10.5t-51.5 25t-36.5 29.5t-23 25l-8 11l61 53q5 -8 14 -20.5t40.5 -33t66.5 -20.5q64 0 93 35t29 83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 589,
    d: "M166 700v-329l283 329h107l-296 -342l329 -358h-114l-309 334v-334h-84v700h84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 488,
    d: "M82 0v700h84v-620h314v-80h-398z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 810,
    d: "M82 700h84l241 -391l240 391h81v-700h-84v548l-239 -389l-239 388v-547h-84v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 710,
    d: "M82 700h87l375 -560v560h84v-700h-87l-375 560v-560h-84v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 768,
    d: "M384 712q150 0 248 -104.5t98 -257.5t-98 -257.5t-248 -104.5t-248 104.5t-98 257.5t98 257.5t248 104.5zM384 68q112 0 184 83.5t72 198.5t-72 198.5t-184 83.5t-184 -83.5t-72 -198.5t72 -198.5t184 -83.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 528,
    d: "M82 0v700h181q111 0 175 -55.5t64 -155.5t-64 -155.5t-175 -55.5h-97v-278h-84zM166 358h92q74 0 117 33t43 98t-43 98t-117 33h-92v-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 791,
    d: "M384 712q150 0 248 -104.5t98 -257.5q0 -129 -73 -227l108 -96l-52 -61l-111 98q-92 -76 -218 -76q-150 0 -248 104.5t-98 257.5t98 257.5t248 104.5zM438 209l53 62l100 -90q50 75 50 169q0 115 -73 198.5t-184 83.5t-183.5 -83.5t-72.5 -198.5t72.5 -198.5t183.5 -83.5 q86 0 152 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 553,
    d: "M269 366q69 0 107 34t38 93t-38 93t-107 34h-103v-254h103zM82 0v700h182q105 0 169.5 -57t64.5 -150q0 -47 -16.5 -84t-37.5 -57.5t-48.5 -34.5t-42.5 -18t-26 -6l194 -293h-101l-189 286h-65v-286h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 542,
    d: "M404 178q0 26 -9 46t-31 37t-40.5 27t-55.5 27t-60 29t-51 32t-43.5 39.5t-26.5 48.5t-11 64q0 69 54.5 126.5t147.5 57.5q37 0 71 -10.5t56.5 -25.5t39.5 -30t25 -26l7 -10l-63 -51q-2 3 -6 8t-17 17.5t-27.5 22t-38 17.5t-47.5 8q-54 0 -86 -31.5t-32 -72.5 q0 -26 9.5 -45.5t34 -37t46 -28.5t66.5 -32t73 -38t53 -41t36.5 -55.5t11.5 -72.5q0 -84 -61.5 -137t-155.5 -53q-46 0 -86.5 15t-64.5 36.5t-41 43t-24 36.5l-7 15l70 42q2 -4 5.5 -11.5t16.5 -26t29 -33t43.5 -26t58.5 -11.5q54 0 92.5 29.5t38.5 80.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 514,
    d: "M215 0v620h-201v80h486v-80h-201v-620h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 674,
    d: "M508 267v433h84v-442q0 -121 -68.5 -195.5t-186.5 -74.5t-186.5 74.5t-68.5 195.5v442h84v-433q0 -90 42 -144.5t129 -54.5t129 54.5t42 144.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 592,
    d: "M588 700l-292 -720l-292 720h92l202 -513l203 513h87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 950,
    d: "M946 700l-270 -720l-201 551l-202 -551l-269 720h94l177 -485l172 485h61l170 -485l179 485h89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 590,
    d: "M473 0l-181 294l-180 -294h-95l226 362l-210 338h99l166 -272l165 272h94l-210 -338l226 -362h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    d: "M248 0v275l-236 425h94l188 -344l185 344h89l-236 -425v-275h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 572,
    d: "M45 700h509l-393 -620h374v-80h-517l393 620h-366v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 313,
    d: "M149 674v-838h114v-66h-188v970h188v-66h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 497,
    d: "M407 -133l-397 897l68 30l397 -897z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 313,
    d: "M164 -164v838h-114v66h188v-970h-188v66h114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 536,
    d: "M28 350l206 406h68l206 -406h-91l-149 302l-151 -302h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 500,
    d: "M42 -230v80h416v-80h-416z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 264,
    d: "M18 649l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 512,
    d: "M247 474q96 0 148.5 -50t52.5 -120v-304h-77v67q-2 -3 -6 -8.5t-19 -19t-31.5 -24t-44 -19t-56.5 -8.5q-67 0 -119.5 43.5t-52.5 114.5q0 67 52 110.5t131 43.5q38 0 72.5 -9.5t50.5 -18.5l16 -10v25q0 34 -12.5 57.5t-32.5 33.5t-37.5 14t-34.5 4q-31 0 -65.5 -10 t-53.5 -20l-19 -9l-35 70q8 5 23 13t60 21t90 13zM232 62q36 0 69 17.5t48 34.5l15 18v65q-46 33 -121 33q-53 0 -85 -23.5t-32 -60.5q0 -42 31 -63t75 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 571,
    d: "M315 474q94 0 159 -70.5t65 -172.5t-65 -172.5t-159 -70.5q-49 0 -88 20t-53 40l-15 19v-67h-77v756h84v-351q2 3 5.5 7.5t17.5 16.5t29.5 21t41.5 16.5t55 7.5zM166 316v-170q2 -3 5.5 -8.5t16 -19.5t27 -24.5t38 -19t49.5 -8.5q69 0 111 47.5t42 117.5t-42.5 117.5 t-110.5 47.5q-26 0 -49.5 -8t-38.5 -20t-26.5 -24t-16.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 477,
    d: "M405 132l54 -55q-3 -4 -8 -10t-23.5 -21t-38.5 -27t-52.5 -21.5t-66.5 -9.5q-102 0 -170 70t-68 173q0 102 68.5 172.5t169.5 70.5q52 0 98 -21t66 -41l20 -21l-57 -51q-5 6 -15 15.5t-43 25t-69 15.5q-68 0 -111 -47.5t-43 -117.5t43 -117.5t111 -47.5q25 0 48.5 7 t38.5 16.5t26.5 19t16.5 16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 571,
    d: "M256 474q29 0 54.5 -7t42 -17t29 -20.5t18.5 -17.5l5 -7v351h84v-756h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30 -24t-44 -19t-59 -8.5q-94 0 -159 70.5t-65 172.5t65 172.5t159 70.5zM405 146v170q-2 3 -5.5 8.5t-16 19.5t-27 24.5t-38 19t-49.5 8.5q-68 0 -110.5 -47.5 t-42.5 -117.5t42 -117.5t111 -47.5q26 0 49.5 8t38.5 20t26.5 24t16.5 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 520,
    d: "M263 474q98 0 161.5 -68t63.5 -178q0 -16 -1 -27h-373q4 -54 49.5 -94.5t109.5 -40.5q40 0 75 17t50 34l14 17l53 -55q-3 -4 -8.5 -10t-24 -21.5t-39 -27.5t-53.5 -22t-67 -10q-104 0 -172.5 70t-68.5 173t64.5 173t166.5 70zM116 271h290q-3 45 -41 85t-102 40 q-67 0 -104 -39.5t-43 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 343,
    d: "M20 386v76h96v159q0 69 43.5 108t98.5 39q48 0 97 -27l-31 -69q-28 18 -54 18q-33 0 -51.5 -20t-18.5 -54v-154h120v-76h-120v-386h-84v386h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 553,
    d: "M405 -6v64q-11 -15 -26.5 -28.5t-49.5 -27.5t-73 -14q-94 0 -159 70.5t-65 172.5t65 172.5t159 70.5q49 0 88 -20t54 -40l14 -19v67h77v-464q0 -115 -68.5 -177.5t-174.5 -62.5q-56 0 -106.5 22t-73.5 44l-22 22l51 63q2 -3 6.5 -8t19.5 -17.5t31 -22t41.5 -17.5t52.5 -8 q75 0 117 40.5t42 117.5zM405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38.5 18.5t-49 8.5q-69 0 -111 -47.5t-42 -117.5t42 -117.5t111 -47.5q26 0 49.5 8t38.5 19.5t26.5 23t16.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 540,
    d: "M302 474q73 0 123.5 -47.5t50.5 -129.5v-297h-84v283q0 56 -31 84.5t-80 28.5q-21 0 -40.5 -8t-32.5 -19.5t-23 -23t-15 -19.5l-4 -8v-318h-84v756h84v-350q48 68 136 68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 242,
    d: "M79 0v462h84v-462h-84zM64 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 257,
    d: "M-24 -221l30 70q23 -13 35 -13q15 0 25 3.5t19 20.5t9 47v555h84v-563q0 -74 -38.5 -107.5t-85.5 -33.5q-42 0 -78 21zM79 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 494,
    d: "M375 0l-209 224v-224h-84v756h84v-499l198 205h110l-216 -218l234 -244h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 248,
    d: "M82 0v756h84v-756h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 776,
    d: "M552 474q73 0 116.5 -46.5t43.5 -130.5v-297h-84v284q0 55 -26.5 83.5t-72.5 28.5q-31 0 -55.5 -18.5t-33.5 -37.5l-10 -18v-322h-84v284q0 55 -26.5 83.5t-72.5 28.5q-30 0 -55 -18.5t-34 -37.5l-10 -18v-322h-84v462h78v-68q1 3 4 8.5t14 19.5t24.5 24.5t36.5 19 t49 8.5q32 0 59 -9t42 -21.5t25.5 -25t13.5 -21.5l4 -9q2 3 5 9t14.5 21t26 26t39.5 20.5t53 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 522,
    d: "M284 474q73 0 123.5 -47.5t50.5 -129.5v-297h-84v283q0 56 -31 84.5t-80 28.5q-21 0 -40.5 -8t-32.5 -19.5t-23 -23t-15 -19.5l-4 -8v-318h-84v462h78v-65q2 3 5.5 8.5t16 18.5t27.5 23t40 18.5t53 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 540,
    d: "M270 474q102 0 170 -70t68 -173t-68 -173t-170 -70t-170 70t-68 173t68 173t170 70zM270 66q68 0 111 47.5t43 117.5t-43 117.5t-111 47.5t-111 -47.5t-43 -117.5t43 -117.5t111 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 553,
    d: "M64 462h77v-67q2 3 5.5 8.5t17.5 19t30.5 24t44 19t58.5 8.5q94 0 159 -70.5t65 -172.5t-65 -172.5t-159 -70.5q-96 0 -149 69v-287h-84v692zM148 317v-172q2 -3 5.5 -8.5t16 -19t27 -24t38 -19t49.5 -8.5q69 0 111 47.5t42 117.5t-42 117.5t-111 47.5q-41 0 -75 -20 t-47 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 553,
    d: "M412 462h77v-692h-84v287q-53 -69 -149 -69q-94 0 -159 70.5t-65 172.5t65 172.5t159 70.5q49 0 88 -20t54 -40l14 -19v67zM405 145v172q-2 3 -5.5 8.5t-16 19t-27 24t-38 19t-49.5 8.5q-69 0 -111 -47.5t-42 -117.5t42 -117.5t111 -47.5q41 0 75 20t48 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 340,
    d: "M271 474q17 0 33.5 -3t25.5 -6l8 -3l-31 -76q-18 10 -53 10q-32 0 -58.5 -19.5t-37.5 -38.5l-10 -20v-318h-84v462h78v-71q2 3 5 9t15 20t25.5 25t36 20t47.5 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 455,
    d: "M34 85l58 54q2 -3 6 -8t17 -18t28 -23t39.5 -18t49.5 -8q39 0 69.5 15.5t30.5 41.5q0 29 -25 46t-80 28q-81 16 -125 50.5t-44 95.5q0 53 48 93t122 40q48 0 91 -17.5t61 -34.5l19 -18l-55 -57q-5 6 -14.5 14.5t-40 22.5t-61.5 14q-42 0 -65 -17.5t-23 -41.5 q0 -26 26.5 -42t85.5 -28q77 -17 120 -49t43 -97q0 -63 -55 -99t-128 -36q-36 0 -70 10t-56 24.5t-39 28.5t-25 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 376,
    d: "M24 386v76h90v141h84v-141h144v-76h-144v-249q0 -71 67 -71q12 0 25 5t20 9l8 5l31 -69q-51 -28 -96 -28q-56 0 -97.5 37t-41.5 108v253h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 522,
    d: "M238 -12q-73 0 -123.5 47.5t-50.5 129.5v297h84v-283q0 -56 31 -84.5t80 -28.5q35 0 63.5 19t39.5 38l12 19v320h84v-462h-78v71q-2 -3 -5.5 -9t-16 -20t-27.5 -25t-40 -20t-53 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 474,
    d: "M6 462h92l142 -313l142 313h86l-231 -482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 742,
    d: "M8 462h91l124 -299l122 299h57l123 -299l123 299h86l-211 -482l-152 347l-152 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 489,
    d: "M32 462h98l117 -170l116 170h93l-155 -224l166 -238h-99l-127 181l-125 -181h-94l168 238z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 500,
    d: "M27 -209l36 69q29 -24 55 -24t41.5 17t30.5 54l36 91l-216 464h95l162 -365l138 365h91q-232 -584 -243 -611q-19 -47 -53.5 -70t-74.5 -23q-25 0 -49.5 8t-36.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 470,
    d: "M48 462h399l-265 -384h254v-78h-402l265 384h-251v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 312,
    d: "M282 740v-72h-10q-34 0 -51 -16.5t-17 -62.5v-204q0 -124 -109 -128v-4q109 -4 109 -128v-204q0 -46 17 -62.5t51 -16.5h10v-72h-20q-136 0 -136 135v220q0 61 -27 81t-73 20v58q46 0 73 20t27 81v220q0 60 38.5 97.5t97.5 37.5h20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 260,
    d: "M90 -230v970h80v-970h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 312,
    d: "M30 668v72h20q59 0 97.5 -37.5t38.5 -97.5v-220q0 -61 27 -81t73 -20v-58q-46 0 -73 -20t-27 -81v-220q0 -135 -136 -135h-20v72h10q34 0 51 16.5t17 62.5v204q0 124 109 128v4q-109 4 -109 128v204q0 46 -17 62.5t-51 16.5h-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 430,
    d: "M77 273l-57 39l5 10t14.5 21.5t25 27.5t36.5 22t48 10q29 0 72.5 -23.5t59.5 -23.5q26 0 44 15t23 29l6 15l56 -39q-1 -4 -4 -10t-13.5 -21.5t-23.5 -27.5t-35.5 -22t-48.5 -10q-32 0 -76.5 23.5t-57.5 23.5q-26 0 -44.5 -15t-24.5 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nbspace",
    unicode: "\xA0",
    horizAdvX: 280
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 277,
    d: "M181 281v-519h-84v519h84zM195 417q0 -23 -16.5 -39.5t-39.5 -16.5t-40 17t-17 39q0 23 17 40t40 17q22 0 39 -17t17 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    d: "M461 132l54 -55q-2 -3 -7 -8.5t-21.5 -20t-35 -25.5t-48 -21.5t-60.5 -12.5v-83h-51v85q-89 11 -146.5 78.5t-57.5 161.5q0 92 57.5 160t146.5 80v87h51v-85q48 -3 89.5 -23.5t59.5 -39.5l18 -19l-57 -51q-4 5 -12.5 13.5t-37 23.5t-60.5 18v-328q35 3 64.5 19.5 t41.5 31.5zM172 231q0 -61 32.5 -105.5t87.5 -56.5v323q-55 -11 -87.5 -56t-32.5 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    d: "M177 519q0 -8 0.5 -14.5t2.5 -14t3 -12.5t5 -14t6.5 -13.5t9 -16t10 -17.5t12.5 -21.5t14 -23.5h170v-64h-138q15 -36 15 -82q0 -26 -7.5 -50.5t-14.5 -35.5l-7 -11q25 -7 63 -34t67 -27q27 0 47.5 16t27.5 32l7 16l62 -43q-2 -4 -5 -11t-15.5 -24.5t-27.5 -30.5t-41 -24 t-55 -11q-40 0 -70 17t-54.5 34t-50.5 17q-27 0 -48 -17t-29 -34l-8 -17l-62 43q4 8 11.5 21t33 39.5t53.5 36.5q39 40 39 100q0 38 -22 80h-111v64h74q-30 49 -40.5 79.5t-10.5 67.5q0 71 52.5 132t154.5 61q53 0 101 -25t69 -49l22 -25l-58 -56q-2 3 -5.5 8t-16.5 18 t-27.5 23t-37.5 18t-47 8q-62 0 -92.5 -37t-30.5 -76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    d: "M88 580l68 -68q61 43 134 43t134 -43l68 68l55 -55l-68 -68q43 -61 43 -134t-43 -134l68 -68l-55 -55l-68 68q-61 -43 -134 -43t-134 43l-68 -68l-55 55l68 68q-43 61 -43 134t43 134l-68 68zM290 483q-68 0 -114 -46.5t-46 -113.5t46.5 -113.5t113.5 -46.5t113.5 46.5 t46.5 113.5t-46.5 113.5t-113.5 46.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    d: "M36 385v64h119l-136 251h90l182 -341l180 341h90l-135 -251h120v-64h-154l-38 -70h192v-64h-213v-251h-84v251h-213v64h191l-38 70h-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 260,
    d: "M90 350v390h80v-390h-80zM90 -230v390h80v-390h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 508,
    d: "M347 -34q0 14 -2.5 25.5t-11 22t-14 17.5t-21.5 17t-23 14t-29 15.5t-29 15.5q-32 17 -44.5 24.5t-36 24.5t-33.5 30.5t-18.5 35t-8.5 46.5q0 97 107 143q-98 58 -98 155q0 68 51.5 114t127.5 46q47 0 87.5 -20.5t58.5 -41.5l17 -20l-59 -54q-4 6 -11.5 15.5t-34.5 25 t-58 15.5q-44 0 -69.5 -23.5t-25.5 -56.5q0 -14 2.5 -25.5t11 -22t14 -17.5t21.5 -17t23 -14t29 -15.5t29 -15.5q32 -17 44.5 -24.5t36 -24.5t33.5 -30.5t18.5 -35t8.5 -46.5q0 -55 -32.5 -90.5t-74.5 -53.5q98 -57 98 -154q0 -68 -51.5 -114t-127.5 -46q-47 0 -87.5 21 t-58.5 41l-17 21l59 54q4 -6 11.5 -15.5t34.5 -25.5t58 -16q44 0 69.5 23.5t25.5 56.5zM256 358l-4 2q-20 -5 -38.5 -13.5t-37.5 -31.5t-19 -55q0 -31 22.5 -50t80.5 -50l5 -3q94 25 94 101q0 31 -22.5 50t-80.5 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 391,
    d: "M48 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM229 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 819,
    d: "M48 350q0 150 106 256t256 106t255.5 -106t105.5 -256t-105.5 -256t-255.5 -106t-256 106t-106 256zM107 350q0 -124 89.5 -213.5t213.5 -89.5t213 89t89 214t-89 214t-213 89t-213.5 -89.5t-89.5 -213.5zM526 257l38 -37q-6 -8 -17 -19t-47 -29.5t-75 -18.5 q-82 0 -137.5 57.5t-55.5 139.5q0 83 55.5 140t137.5 57q38 0 72.5 -16.5t50.5 -32.5l15 -16l-41 -36q-4 5 -12.5 12.5t-33.5 20.5t-51 13q-61 0 -96 -39.5t-35 -102.5q0 -62 35 -101.5t96 -39.5q26 0 51 12.5t38 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 328,
    d: "M151 483q19 0 35 8t22 16l7 8v23q-26 18 -63 18q-19 0 -34.5 -8.5t-15.5 -27.5t15 -28t34 -9zM158 712q57 0 91.5 -29.5t34.5 -72.5v-178h-64v35q-3 -5 -9.5 -12t-29.5 -18.5t-51 -11.5q-38 0 -67.5 25.5t-29.5 66.5q0 40 29.5 65.5t74.5 25.5q23 0 42.5 -5t27.5 -11 l8 -5v16q0 24 -20 35t-43 11q-19 0 -37.5 -5.5t-28.5 -11.5l-9 -6l-30 56q42 30 111 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 488,
    d: "M191 14l-177 231l177 231l59 -44l-146 -187l146 -187zM374 14l-177 231l177 231l59 -44l-146 -187l146 -187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 678,
    d: "M22 422v78h600v-300h-76v222h-524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 333,
    d: "M33 204v80h267v-80h-267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 451,
    d: "M154 437v192h91q28 0 45.5 -18.5t17.5 -44.5q0 -21 -11.5 -37t-31.5 -22l50 -70h-56l-42 65h-15v-65h-48zM230 542q30 0 30 24t-30 24h-28v-48h28zM22 531q0 84 59.5 144t143.5 60t144 -60t60 -144t-60 -143.5t-144 -59.5t-143.5 59.5t-59.5 143.5zM73 531 q0 -64 44.5 -108.5t108.5 -44.5t109 44.5t45 108.5t-45 109t-109 45t-108.5 -45t-44.5 -109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 314,
    d: "M6 572v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 332,
    d: "M310 568q0 -59 -42.5 -101.5t-101.5 -42.5t-101.5 42.5t-42.5 101.5t42.5 101.5t101.5 42.5t101.5 -42.5t42.5 -101.5zM94 567q0 -30 20.5 -50.5t50.5 -20.5t51 20.5t21 50.5t-21 51t-51 21t-50.5 -21t-20.5 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 520,
    d: "M45 0v68h430v-68h-430zM45 261v70h178v143h74v-143h178v-70h-178v-149h-74v149h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 350,
    d: "M256 559l-100 -111h152v-54h-279l165 181q17 19 26 29.5t18 29.5t9 38q0 34 -20.5 58t-59.5 24q-62 0 -88 -71l-51 21q14 43 51 72.5t88 29.5q60 0 98 -36.5t38 -97.5q0 -58 -47 -113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 352,
    d: "M251 692q0 27 -19.5 44.5t-51.5 17.5q-27 0 -47.5 -14t-27.5 -28l-7 -14l-46 23q1 3 4 9t13.5 20.5t23.5 26t36.5 20.5t50.5 9q55 0 91 -32.5t36 -81.5q0 -18 -5.5 -34t-13.5 -25.5t-16.5 -16t-13.5 -9.5l-6 -3q2 -1 6 -2.5t14 -8.5t17.5 -17t14 -28.5t6.5 -42.5 q0 -53 -40.5 -85t-98.5 -32q-30 0 -55 10t-39 24t-24 28.5t-13 24.5l-4 10l47 23l2.5 -7.5t8.5 -16t16 -20.5t25 -16.5t36 -7.5q35 0 59 17.5t24 47.5q0 71 -78 71h-24v52h17q36 0 59 15.5t23 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 264,
    d: "M194 701l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 528,
    d: "M66 -230v692h84v-279q0 -57 31 -87t80 -30q22 0 42.5 8t33.5 19.5t22.5 23t14.5 19.5l4 8v318h84v-462h-78v71q-2 -3 -5 -9t-16 -20t-28 -25t-40.5 -20t-54.5 -9q-49 0 -90 22v-240h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\u03BC",
    horizAdvX: 528,
    d: "M66 -230v692h84v-279q0 -57 31 -87t80 -30q22 0 42.5 8t33.5 19.5t22.5 23t14.5 19.5l4 8v318h84v-462h-78v71q-2 -3 -5 -9t-16 -20t-28 -25t-40.5 -20t-54.5 -9q-49 0 -90 22v-240h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 618,
    d: "M358 622v-810h-84v414q-98 0 -168 69t-70 167t70 168t168 70h262v-888h-84v810h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 230,
    d: "M58 350q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 315,
    d: "M227 -56l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 288,
    d: "M12 677l148 123h48v-406h-56v330l-107 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 332,
    d: "M310 568q0 -59 -42.5 -101.5t-101.5 -42.5t-101.5 42.5t-42.5 101.5t42.5 101.5t101.5 42.5t101.5 -42.5t42.5 -101.5zM87 568q0 -35 22.5 -56.5t56.5 -21.5t56.5 21.5t22.5 56.5t-22.5 57t-56.5 22t-56.5 -22t-22.5 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 488,
    d: "M474 245l-177 -231l-59 44l146 187l-146 187l59 44zM114 476l177 -231l-177 -231l-59 44l146 187l-146 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 830,
    d: "M466 93l217 313h50v-259h54v-54h-54v-93h-56v93h-211zM564 147h113v164zM46 577l148 123h48v-406h-56v330l-107 -88zM189 0l475 730l43 -30l-473 -731z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 830,
    d: "M714 165l-100 -111h152v-54h-279l165 181q17 19 26 29.5t18 29.5t9 38q0 34 -20.5 58t-59.5 24q-62 0 -88 -71l-51 21q14 43 51 72.5t88 29.5q60 0 98 -36.5t38 -97.5q0 -58 -47 -113zM141 0l475 730l43 -30l-473 -731zM46 577l148 123h48v-406h-56v330l-107 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 830,
    d: "M189 0l475 730l43 -30l-473 -731zM467 93l217 313h50v-259h54v-54h-54v-93h-56v93h-211zM565 147h113v164zM264 592q0 27 -19.5 44.5t-51.5 17.5q-27 0 -47.5 -14t-27.5 -28l-7 -14l-46 23q1 3 4 9t13.5 20.5t23.5 26t36.5 20.5t50.5 9q55 0 91 -32.5t36 -81.5 q0 -29 -14 -51t-28 -29l-13 -8q2 -1 6 -2.5t14 -8.5t17.5 -17t14 -28.5t6.5 -42.5q0 -53 -40.5 -85t-98.5 -32q-30 0 -55 10t-39 24t-24 28.5t-14 24.5l-3 10l47 23l2.5 -7.5t8.5 -16t16 -20.5t25 -16.5t36 -7.5q35 0 59 17.5t24 47.5q0 71 -78 71h-24v52h17q36 0 59 15.5 t23 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 482,
    d: "M130 -57q0 -47 35 -81t85 -34q46 0 80.5 26t46.5 52l12 25l72 -34q-2 -6 -6 -16t-21 -35t-38.5 -44.5t-60.5 -35.5t-85 -16q-84 0 -144 55.5t-60 137.5q0 34 9.5 63.5t28.5 53.5t33 37.5t36 32.5q41 33 48.5 46.5t7.5 47.5v58h78v-58q0 -53 -11.5 -77t-58.5 -65 q-4 -4 -15.5 -13t-16 -13.5t-14 -13.5t-14 -15t-11 -16t-9 -19.5t-5 -22t-2.5 -26.5zM304 418q0 -23 -16.5 -40t-39.5 -17t-40 17t-17 40t17 39.5t40 16.5t39.5 -16.5t16.5 -39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 642,
    d: "M8 0l275 700h78l273 -700h-88l-73 189h-302l-73 -189h-90zM322 580l-120 -311h240zM193 887l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 642,
    d: "M8 0l275 700h78l273 -700h-88l-73 189h-302l-73 -189h-90zM322 580l-120 -311h240zM399 939l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 642,
    d: "M8 0l275 700h78l273 -700h-88l-73 189h-302l-73 -189h-90zM322 580l-120 -311h240zM324 920l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 642,
    d: "M8 0l275 700h78l273 -700h-88l-73 189h-302l-73 -189h-90zM322 580l-120 -311h240zM209 771l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9q28 0 64 -22.5t48 -22.5q19 0 33 12.5t19 24.5l5 13l58 -37l-3 -9t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5 t-48 22.5q-19 0 -33.5 -12.5t-18.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 642,
    d: "M8 0l275 700h78l273 -700h-88l-73 189h-302l-73 -189h-90zM322 580l-120 -311h240zM174 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM355 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 642,
    d: "M8 0l275 700h78l273 -700h-88l-73 189h-302l-73 -189h-90zM322 580l-120 -311h240zM267 840q0 -23 16 -39t39 -16t39 16t16 39t-16 39t-39 16t-39 -16t-16 -39zM214 840q0 45 31.5 76.5t76.5 31.5t76.5 -31.5t31.5 -76.5t-31.5 -76.5t-76.5 -31.5t-76.5 31.5t-31.5 76.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 885,
    d: "M8 0l408 700h411v-80h-280v-221h256v-80h-256v-239h286v-80h-370v189h-252l-110 -189h-93zM257 269h206v352z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 663,
    d: "M397 -56l-59 -198l-80 24l62 183zM635 605l-58 -55q-3 3 -8 8.5t-23 20t-38.5 25t-54 19.5t-69.5 9q-111 0 -183.5 -83.5t-72.5 -198.5t72.5 -198.5t183.5 -83.5q36 0 69.5 9.5t56.5 23.5t41 27.5t27 23.5l8 9l57 -58q-4 -5 -11.5 -12.5t-32.5 -27.5t-53 -35t-72 -27.5 t-90 -12.5q-150 0 -248 104.5t-98 257.5t98 257.5t248 104.5q73 0 135.5 -27t88.5 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 544,
    d: "M166 620v-221h296v-80h-296v-239h326v-80h-410v700h404v-80h-320zM161 887l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 544,
    d: "M166 620v-221h296v-80h-296v-239h326v-80h-410v700h404v-80h-320zM349 939l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 544,
    d: "M166 620v-221h296v-80h-296v-239h326v-80h-410v700h404v-80h-320zM283 920l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 544,
    d: "M166 620v-221h296v-80h-296v-239h326v-80h-410v700h404v-80h-320zM141 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM322 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 276,
    d: "M96 0v700h84v-700h-84zM20 887l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 276,
    d: "M204 939l52 -52l-151 -144l-50 47zM96 0v700h84v-700h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 276,
    d: "M96 0v700h84v-700h-84zM138 922l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 276,
    d: "M85 0v700h84v-700h-84zM-20 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM161 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 672,
    d: "M12 326v70h85v304h191q151 0 248.5 -99t97.5 -251t-97.5 -251t-248.5 -99h-191v326h-85zM288 80q112 0 184 78t72 192t-72 192t-184 78h-107v-224h203v-70h-203v-246h107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 710,
    d: "M82 700h87l375 -560v560h84v-700h-87l-375 560v-560h-84v700zM247 791l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9q28 0 64 -22.5t48 -22.5q19 0 33 12.5t19 24.5l5 13l58 -37l-3 -9t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5t-48 22.5 q-19 0 -33.5 -12.5t-18.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 768,
    d: "M384 712q150 0 248 -104.5t98 -257.5t-98 -257.5t-248 -104.5t-248 104.5t-98 257.5t98 257.5t248 104.5zM384 68q112 0 184 83.5t72 198.5t-72 198.5t-184 83.5t-184 -83.5t-72 -198.5t72 -198.5t184 -83.5zM261 897l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 768,
    d: "M447 949l52 -52l-151 -144l-50 47zM384 712q150 0 248 -104.5t98 -257.5t-98 -257.5t-248 -104.5t-248 104.5t-98 257.5t98 257.5t248 104.5zM384 68q112 0 184 83.5t72 198.5t-72 198.5t-184 83.5t-184 -83.5t-72 -198.5t72 -198.5t184 -83.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 768,
    d: "M384 712q150 0 248 -104.5t98 -257.5t-98 -257.5t-248 -104.5t-248 104.5t-98 257.5t98 257.5t248 104.5zM384 68q112 0 184 83.5t72 198.5t-72 198.5t-184 83.5t-184 -83.5t-72 -198.5t72 -198.5t184 -83.5zM384 922l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 768,
    d: "M384 712q150 0 248 -104.5t98 -257.5t-98 -257.5t-248 -104.5t-248 104.5t-98 257.5t98 257.5t248 104.5zM384 68q112 0 184 83.5t72 198.5t-72 198.5t-184 83.5t-184 -83.5t-72 -198.5t72 -198.5t184 -83.5zM272 771l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9 q28 0 64 -22.5t48 -22.5q19 0 33 12.5t19 24.5l5 13l58 -37l-3 -9t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5t-48 22.5q-19 0 -33.5 -12.5t-19.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 768,
    d: "M384 712q150 0 248 -104.5t98 -257.5t-98 -257.5t-248 -104.5t-248 104.5t-98 257.5t98 257.5t248 104.5zM384 68q112 0 184 83.5t72 198.5t-72 198.5t-184 83.5t-184 -83.5t-72 -198.5t72 -198.5t184 -83.5zM237 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17 t-40 17t-17 40zM418 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 520,
    d: "M41 425l49 49l170 -170l170 170l49 -49l-170 -170l170 -170l-49 -49l-170 170l-170 -170l-49 49l170 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 776,
    d: "M388 712q122 0 214 -73l74 88l44 -38l-76 -90q90 -103 90 -249q0 -153 -98 -257.5t-248 -104.5q-115 0 -204 65l-69 -81l-44 38l69 82q-98 104 -98 258q0 153 98 257.5t248 104.5zM132 350q0 -109 65 -190l349 413q-67 59 -158 59q-111 0 -183.5 -83.5t-72.5 -198.5z M388 68q111 0 183.5 83.5t72.5 198.5q0 102 -58 180l-347 -411q64 -51 149 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 674,
    d: "M508 267v433h84v-442q0 -121 -68.5 -195.5t-186.5 -74.5t-186.5 74.5t-68.5 195.5v442h84v-433q0 -90 42 -144.5t129 -54.5t129 54.5t42 144.5zM193 887l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 674,
    d: "M508 267v433h84v-442q0 -121 -68.5 -195.5t-186.5 -74.5t-186.5 74.5t-68.5 195.5v442h84v-433q0 -90 42 -144.5t129 -54.5t129 54.5t42 144.5zM430 939l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 674,
    d: "M508 267v433h84v-442q0 -121 -68.5 -195.5t-186.5 -74.5t-186.5 74.5t-68.5 195.5v442h84v-433q0 -90 42 -144.5t129 -54.5t129 54.5t42 144.5zM337 921l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 674,
    d: "M508 267v433h84v-442q0 -121 -68.5 -195.5t-186.5 -74.5t-186.5 74.5t-68.5 195.5v442h84v-433q0 -90 42 -144.5t129 -54.5t129 54.5t42 144.5zM190 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM371 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40 t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    d: "M248 0v275l-236 425h94l188 -344l185 344h89l-236 -425v-275h-84zM379 939l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 540,
    d: "M82 0v700h84v-127h105q107 0 172 -50.5t65 -147.5t-65 -147.5t-172 -50.5h-105v-177h-84zM271 257q74 0 113.5 27t39.5 91t-39.5 91t-113.5 27h-105v-236h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 568,
    d: "M66 0v553q0 97 53 156t149 59q26 0 53.5 -6t54.5 -21t48.5 -36.5t34.5 -55t13 -74.5q0 -31 -9.5 -57t-23 -41.5t-27.5 -26.5t-24 -15l-9 -4q6 -1 15.5 -4.5t34.5 -18.5t44.5 -35.5t35 -59t15.5 -86.5q0 -61 -23 -108.5t-61 -75t-82 -41.5t-91 -14h-30v78h25 q87 0 132.5 45.5t45.5 115.5t-49 115.5t-144 45.5v74q77 0 109 33.5t32 80.5q0 40 -28 77t-92 37q-63 0 -90.5 -41.5t-27.5 -101.5v-547h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 512,
    d: "M247 474q96 0 148.5 -50t52.5 -120v-304h-77v67q-2 -3 -6 -8.5t-19 -19t-31.5 -24t-44 -19t-56.5 -8.5q-67 0 -119.5 43.5t-52.5 114.5q0 67 52 110.5t131 43.5q38 0 72.5 -9.5t50.5 -18.5l16 -10v25q0 34 -12.5 57.5t-32.5 33.5t-37.5 14t-34.5 4q-31 0 -65.5 -10 t-53.5 -20l-19 -9l-35 70q8 5 23 13t60 21t90 13zM232 62q36 0 69 17.5t48 34.5l15 18v65q-46 33 -121 33q-53 0 -85 -23.5t-32 -60.5q0 -42 31 -63t75 -21zM157 669l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 512,
    d: "M358 721l52 -52l-151 -144l-50 47zM247 474q96 0 148.5 -50t52.5 -120v-304h-77v67q-2 -3 -6 -8.5t-19 -19t-31.5 -24t-44 -19t-56.5 -8.5q-67 0 -119.5 43.5t-52.5 114.5q0 67 52 110.5t131 43.5q38 0 72.5 -9.5t50.5 -18.5l16 -10v25q0 34 -12.5 57.5t-32.5 33.5 t-37.5 14t-34.5 4q-31 0 -65.5 -10t-53.5 -20l-19 -9l-35 70q8 5 23 13t60 21t90 13zM232 62q36 0 69 17.5t48 34.5l15 18v65q-46 33 -121 33q-53 0 -85 -23.5t-32 -60.5q0 -42 31 -63t75 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 512,
    d: "M247 474q96 0 148.5 -50t52.5 -120v-304h-77v67q-2 -3 -6 -8.5t-19 -19t-31.5 -24t-44 -19t-56.5 -8.5q-67 0 -119.5 43.5t-52.5 114.5q0 67 52 110.5t131 43.5q38 0 72.5 -9.5t50.5 -18.5l16 -10v25q0 34 -12.5 57.5t-32.5 33.5t-37.5 14t-34.5 4q-31 0 -65.5 -10 t-53.5 -20l-19 -9l-35 70q8 5 23 13t60 21t90 13zM232 62q36 0 69 17.5t48 34.5l15 18v65q-46 33 -121 33q-53 0 -85 -23.5t-32 -60.5q0 -42 31 -63t75 -21zM267 702l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 512,
    d: "M247 474q96 0 148.5 -50t52.5 -120v-304h-77v67q-2 -3 -6 -8.5t-19 -19t-31.5 -24t-44 -19t-56.5 -8.5q-67 0 -119.5 43.5t-52.5 114.5q0 67 52 110.5t131 43.5q38 0 72.5 -9.5t50.5 -18.5l16 -10v25q0 34 -12.5 57.5t-32.5 33.5t-37.5 14t-34.5 4q-31 0 -65.5 -10 t-53.5 -20l-19 -9l-35 70q8 5 23 13t60 21t90 13zM232 62q36 0 69 17.5t48 34.5l15 18v65q-46 33 -121 33q-53 0 -85 -23.5t-32 -60.5q0 -42 31 -63t75 -21zM149 552l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9q28 0 64 -22.5t48 -22.5q19 0 33 12.5t19 25.5l5 12 l58 -37l-3 -9t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5t-48 22.5q-19 0 -33.5 -12.5t-18.5 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 512,
    d: "M247 474q96 0 148.5 -50t52.5 -120v-304h-77v67q-2 -3 -6 -8.5t-19 -19t-31.5 -24t-44 -19t-56.5 -8.5q-67 0 -119.5 43.5t-52.5 114.5q0 67 52 110.5t131 43.5q38 0 72.5 -9.5t50.5 -18.5l16 -10v25q0 34 -12.5 57.5t-32.5 33.5t-37.5 14t-34.5 4q-31 0 -65.5 -10 t-53.5 -20l-19 -9l-35 70q8 5 23 13t60 21t90 13zM232 62q36 0 69 17.5t48 34.5l15 18v65q-46 33 -121 33q-53 0 -85 -23.5t-32 -60.5q0 -42 31 -63t75 -21zM115 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM296 610q0 23 17 40t40 17t40 -17 t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 512,
    d: "M247 474q96 0 148.5 -50t52.5 -120v-304h-77v67q-2 -3 -6 -8.5t-19 -19t-31.5 -24t-44 -19t-56.5 -8.5q-67 0 -119.5 43.5t-52.5 114.5q0 67 52 110.5t131 43.5q38 0 72.5 -9.5t50.5 -18.5l16 -10v25q0 34 -12.5 57.5t-32.5 33.5t-37.5 14t-34.5 4q-31 0 -65.5 -10 t-53.5 -20l-19 -9l-35 70q8 5 23 13t60 21t90 13zM232 62q36 0 69 17.5t48 34.5l15 18v65q-46 33 -121 33q-53 0 -85 -23.5t-32 -60.5q0 -42 31 -63t75 -21zM206 645q0 -23 16 -39t39 -16t39 16t16 39t-16 39t-39 16t-39 -16t-16 -39zM153 645q0 45 31.5 76.5t76.5 31.5 t76.5 -31.5t31.5 -76.5t-31.5 -76.5t-76.5 -31.5t-76.5 31.5t-31.5 76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 820,
    d: "M579 474q96 0 158 -67.5t62 -178.5q0 -16 -1 -27h-363q2 -54 47 -94.5t106 -40.5q41 0 78 19t61 50l52 -54q-34 -41 -85.5 -67t-105.5 -26q-61 0 -112.5 28.5t-81.5 75.5q-26 -45 -74 -74.5t-110 -29.5q-70 0 -119 39t-49 107q0 41 16.5 69.5t44 42t53.5 19t54 5.5h144v9 q0 56 -38.5 86.5t-93.5 30.5q-29 0 -58.5 -10.5t-44.5 -21.5l-15 -10l-42 66q8 6 22 15t56 24t82 15q132 0 187 -81q67 81 170 81zM437 270h279q-2 46 -37.5 86t-99.5 40q-63 0 -101 -41t-41 -85zM210 66q64 0 104 36t40 71v28q-37 2 -119 2q-23 0 -38.5 -2t-33.5 -8.5 t-27.5 -21t-9.5 -37.5q0 -34 27 -51t57 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 477,
    d: "M405 132l54 -55q-3 -4 -8 -10t-23.5 -21t-38.5 -27t-52.5 -21.5t-66.5 -9.5q-102 0 -170 70t-68 173q0 102 68.5 172.5t169.5 70.5q52 0 98 -21t66 -41l20 -21l-57 -51q-5 6 -15 15.5t-43 25t-69 15.5q-68 0 -111 -47.5t-43 -117.5t43 -117.5t111 -47.5q25 0 48.5 7 t38.5 16.5t26.5 19t16.5 16.5zM300 -56l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 520,
    d: "M263 474q98 0 161.5 -68t63.5 -178q0 -16 -1 -27h-373q4 -54 49.5 -94.5t109.5 -40.5q40 0 75 17t50 34l14 17l53 -55q-3 -4 -8.5 -10t-24 -21.5t-39 -27.5t-53.5 -22t-67 -10q-104 0 -172.5 70t-68.5 173t64.5 173t166.5 70zM116 271h290q-3 45 -41 85t-102 40 q-67 0 -104 -39.5t-43 -85.5zM162 670l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 520,
    d: "M323 721l52 -52l-151 -144l-50 47zM263 474q98 0 161.5 -68t63.5 -178q0 -16 -1 -27h-373q4 -54 49.5 -94.5t109.5 -40.5q40 0 75 17t50 34l14 17l53 -55q-3 -4 -8.5 -10t-24 -21.5t-39 -27.5t-53.5 -22t-67 -10q-104 0 -172.5 70t-68.5 173t64.5 173t166.5 70zM116 271 h290q-3 45 -41 85t-102 40q-67 0 -104 -39.5t-43 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 520,
    d: "M263 474q98 0 161.5 -68t63.5 -178q0 -16 -1 -27h-373q4 -54 49.5 -94.5t109.5 -40.5q40 0 75 17t50 34l14 17l53 -55q-3 -4 -8.5 -10t-24 -21.5t-39 -27.5t-53.5 -22t-67 -10q-104 0 -172.5 70t-68.5 173t64.5 173t166.5 70zM116 271h290q-3 45 -41 85t-102 40 q-67 0 -104 -39.5t-43 -85.5zM270 702l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 520,
    d: "M263 474q98 0 161.5 -68t63.5 -178q0 -16 -1 -27h-373q4 -54 49.5 -94.5t109.5 -40.5q40 0 75 17t50 34l14 17l53 -55q-3 -4 -8.5 -10t-24 -21.5t-39 -27.5t-53.5 -22t-67 -10q-104 0 -172.5 70t-68.5 173t64.5 173t166.5 70zM116 271h290q-3 45 -41 85t-102 40 q-67 0 -104 -39.5t-43 -85.5zM117 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM298 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 224,
    d: "M3 669l52 52l149 -149l-50 -47zM70 0v462h84v-462h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 229,
    d: "M174 721l52 -52l-151 -144l-50 47zM70 0v462h84v-462h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 256,
    d: "M86 0v462h84v-462h-84zM128 712l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 245,
    d: "M-25 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM156 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM80 0v462h84v-462h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 544,
    d: "M129 529l-30 64l97 45q-53 34 -112 65l34 65q85 -42 158 -93l126 59l30 -64l-94 -44q170 -152 170 -354q0 -141 -65.5 -212.5t-172.5 -71.5q-102 0 -170 70t-68 173t68 173t170 70q36 0 68.5 -12t46.5 -24l14 -13q-38 86 -138 165zM272 66q68 0 111 47.5t43 117.5 q0 71 -42.5 118t-111.5 47q-68 0 -111 -47.5t-43 -117.5t43 -117.5t111 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 522,
    d: "M284 474q73 0 123.5 -47.5t50.5 -129.5v-297h-84v283q0 56 -31 84.5t-80 28.5q-21 0 -40.5 -8t-32.5 -19.5t-23 -23t-15 -19.5l-4 -8v-318h-84v462h78v-65q2 3 5.5 8.5t16 18.5t27.5 23t40 18.5t53 8.5zM150 553l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9 q28 0 64 -22.5t48 -22.5q19 0 33 12.5t19 24.5l5 13l58 -37l-3 -9t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5t-48 22.5q-19 0 -33.5 -12.5t-19.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 540,
    d: "M270 474q102 0 170 -70t68 -173t-68 -173t-170 -70t-170 70t-68 173t68 173t170 70zM270 66q68 0 111 47.5t43 117.5t-43 117.5t-111 47.5t-111 -47.5t-43 -117.5t43 -117.5t111 -47.5zM146 669l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 540,
    d: "M332 721l52 -52l-151 -144l-50 47zM270 474q102 0 170 -70t68 -173t-68 -173t-170 -70t-170 70t-68 173t68 173t170 70zM270 66q68 0 111 47.5t43 117.5t-43 117.5t-111 47.5t-111 -47.5t-43 -117.5t43 -117.5t111 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 540,
    d: "M270 474q102 0 170 -70t68 -173t-68 -173t-170 -70t-170 70t-68 173t68 173t170 70zM270 66q68 0 111 47.5t43 117.5t-43 117.5t-111 47.5t-111 -47.5t-43 -117.5t43 -117.5t111 -47.5zM270 702l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 540,
    d: "M270 474q102 0 170 -70t68 -173t-68 -173t-170 -70t-170 70t-68 173t68 173t170 70zM270 66q68 0 111 47.5t43 117.5t-43 117.5t-111 47.5t-111 -47.5t-43 -117.5t43 -117.5t111 -47.5zM159 553l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9q28 0 64 -22.5t48 -22.5 q19 0 33 12.5t19 24.5l5 13l58 -37l-3 -9t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5t-48 22.5q-19 0 -33.5 -12.5t-18.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 540,
    d: "M270 474q102 0 170 -70t68 -173t-68 -173t-170 -70t-170 70t-68 173t68 173t170 70zM270 66q68 0 111 47.5t43 117.5t-43 117.5t-111 47.5t-111 -47.5t-43 -117.5t43 -117.5t111 -47.5zM123 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM304 610 q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 520,
    d: "M45 214v74h430v-74h-430zM202 95q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM202 417q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 548,
    d: "M274 474q75 0 135 -41l40 48l43 -37l-41 -49q61 -69 61 -164q0 -103 -68 -173t-170 -70q-74 0 -132 39l-39 -46l-43 37l39 46q-63 68 -63 167q0 103 68 173t170 70zM120 231q0 -61 32 -104l205 245q-37 24 -83 24q-68 0 -111 -47.5t-43 -117.5zM274 66q68 0 111 47.5 t43 117.5q0 57 -30 101l-205 -244q36 -22 81 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 522,
    d: "M238 -12q-73 0 -123.5 47.5t-50.5 129.5v297h84v-283q0 -56 31 -84.5t80 -28.5q35 0 63.5 19t39.5 38l12 19v320h84v-462h-78v71q-2 -3 -5.5 -9t-16 -20t-27.5 -25t-40 -20t-53 -9zM134 669l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 522,
    d: "M340 721l52 -52l-151 -144l-50 47zM238 -12q-73 0 -123.5 47.5t-50.5 129.5v297h84v-283q0 -56 31 -84.5t80 -28.5q35 0 63.5 19t39.5 38l12 19v320h84v-462h-78v71q-2 -3 -5.5 -9t-16 -20t-27.5 -25t-40 -20t-53 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 522,
    d: "M238 -12q-73 0 -123.5 47.5t-50.5 129.5v297h84v-283q0 -56 31 -84.5t80 -28.5q35 0 63.5 19t39.5 38l12 19v320h84v-462h-78v71q-2 -3 -5.5 -9t-16 -20t-27.5 -25t-40 -20t-53 -9zM262 712l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 522,
    d: "M238 -12q-73 0 -123.5 47.5t-50.5 129.5v297h84v-283q0 -56 31 -84.5t80 -28.5q35 0 63.5 19t39.5 38l12 19v320h84v-462h-78v71q-2 -3 -5.5 -9t-16 -20t-27.5 -25t-40 -20t-53 -9zM114 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM295 610 q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 500,
    d: "M323 721l52 -52l-151 -144l-50 47zM27 -209l36 69q29 -24 55 -24t41.5 17t30.5 54l36 91l-216 464h95l162 -365l138 365h91q-232 -584 -243 -611q-19 -47 -53.5 -70t-74.5 -23q-25 0 -49.5 8t-36.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 571,
    d: "M166 756v-351q52 69 149 69q94 0 159 -70.5t65 -172.5t-65 -172.5t-159 -70.5q-96 0 -149 69v-287h-84v986h84zM166 317v-172q2 -3 5.5 -8.5t16 -19t27 -24t38 -19t49.5 -8.5q69 0 111 47.5t42 117.5t-42 117.5t-111 47.5q-41 0 -75 -20t-47 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 500,
    d: "M27 -209l36 69q29 -24 55 -24t41.5 17t30.5 54l36 91l-216 464h95l162 -365l138 365h91q-232 -584 -243 -611q-19 -47 -53.5 -70t-74.5 -23q-25 0 -49.5 8t-36.5 16zM110 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM291 610q0 23 17 40t40 17 t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 642,
    d: "M8 0l275 700h78l273 -700h-88l-73 189h-302l-73 -189h-90zM322 580l-120 -311h240zM170 790v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 512,
    d: "M247 474q96 0 148.5 -50t52.5 -120v-304h-77v67q-2 -3 -6 -8.5t-19 -19t-31.5 -24t-44 -19t-56.5 -8.5q-67 0 -119.5 43.5t-52.5 114.5q0 67 52 110.5t131 43.5q38 0 72.5 -9.5t50.5 -18.5l16 -10v25q0 34 -12.5 57.5t-32.5 33.5t-37.5 14t-34.5 4q-31 0 -65.5 -10 t-53.5 -20l-19 -9l-35 70q8 5 23 13t60 21t90 13zM232 62q36 0 69 17.5t48 34.5l15 18v65q-46 33 -121 33q-53 0 -85 -23.5t-32 -60.5q0 -42 31 -63t75 -21zM120 572v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 642,
    d: "M8 0l275 700h78l273 -700h-88l-73 189h-302l-73 -189h-90zM322 580l-120 -311h240zM167 908h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t20.5 41.5l2 20h75q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 512,
    d: "M247 474q96 0 148.5 -50t52.5 -120v-304h-77v67q-2 -3 -6 -8.5t-19 -19t-31.5 -24t-44 -19t-56.5 -8.5q-67 0 -119.5 43.5t-52.5 114.5q0 67 52 110.5t131 43.5q38 0 72.5 -9.5t50.5 -18.5l16 -10v25q0 34 -12.5 57.5t-32.5 33.5t-37.5 14t-34.5 4q-31 0 -65.5 -10 t-53.5 -20l-19 -9l-35 70q8 5 23 13t60 21t90 13zM232 62q36 0 69 17.5t48 34.5l15 18v65q-46 33 -121 33q-53 0 -85 -23.5t-32 -60.5q0 -42 31 -63t75 -21zM101 700h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t20.5 41.5l2 20h75q0 -6 -1 -16t-10 -36 t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 642,
    d: "M8 0l275 700h78l273 -700q-7 0 -27.5 -6t-45 -26t-24.5 -47q0 -23 14.5 -36t36.5 -13q10 0 19 2t13 4l4 1v-69q-18 -7 -46 -7q-47 0 -77 29.5t-30 72.5q0 72 72 102l-70 182h-302l-73 -189h-90zM322 580l-120 -311h240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 512,
    d: "M247 474q96 0 148.5 -50t52.5 -120v-304h-1q-7 -2 -16 -5t-27.5 -12.5t-30.5 -25.5t-12 -36q0 -23 14.5 -36t36.5 -13q10 0 19 2t13 4l4 1v-69q-18 -7 -46 -7q-47 0 -77 29.5t-30 72.5q0 26 10 47t25 33t24.5 17.5t16.5 7.5v57q-2 -3 -6 -8.5t-19 -19t-31.5 -24t-44 -19 t-56.5 -8.5q-67 0 -119.5 43.5t-52.5 114.5q0 67 52 110.5t131 43.5q38 0 72.5 -9.5t50.5 -18.5l16 -10v25q0 27 -9.5 48t-22.5 32t-31 18t-32 9t-27 2q-31 0 -64.5 -10t-51.5 -20l-17 -9l-35 70q8 5 23 13t60 21t90 13zM232 62q36 0 69 17.5t48 34.5l15 18v65 q-46 33 -121 33q-53 0 -85 -23.5t-32 -60.5q0 -42 31 -63t75 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 663,
    d: "M635 605l-58 -55q-3 3 -8 8.5t-23 20t-38.5 25t-54 19.5t-69.5 9q-111 0 -183.5 -83.5t-72.5 -198.5t72.5 -198.5t183.5 -83.5q36 0 69.5 9.5t56.5 23.5t41 27.5t27 23.5l8 9l57 -58q-4 -5 -11.5 -12.5t-32.5 -27.5t-53 -35t-72 -27.5t-90 -12.5q-150 0 -248 104.5 t-98 257.5t98 257.5t248 104.5q73 0 135.5 -27t88.5 -53zM436 939l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 477,
    d: "M405 132l54 -55q-3 -4 -8 -10t-23.5 -21t-38.5 -27t-52.5 -21.5t-66.5 -9.5q-102 0 -170 70t-68 173q0 102 68.5 172.5t169.5 70.5q52 0 98 -21t66 -41l20 -21l-57 -51q-5 6 -15 15.5t-43 25t-69 15.5q-68 0 -111 -47.5t-43 -117.5t43 -117.5t111 -47.5q25 0 48.5 7 t38.5 16.5t26.5 19t16.5 16.5zM312 712l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 663,
    d: "M635 605l-58 -55q-3 3 -8 8.5t-23 20t-38.5 25t-54 19.5t-69.5 9q-111 0 -183.5 -83.5t-72.5 -198.5t72.5 -198.5t183.5 -83.5q36 0 69.5 9.5t56.5 23.5t41 27.5t27 23.5l8 9l57 -58q-4 -5 -11.5 -12.5t-32.5 -27.5t-53 -35t-72 -27.5t-90 -12.5q-150 0 -248 104.5 t-98 257.5t98 257.5t248 104.5q73 0 135.5 -27t88.5 -53zM379 941l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 477,
    d: "M405 132l54 -55q-3 -4 -8 -10t-23.5 -21t-38.5 -27t-52.5 -21.5t-66.5 -9.5q-102 0 -170 70t-68 173q0 102 68.5 172.5t169.5 70.5q52 0 98 -21t66 -41l20 -21l-57 -51q-5 6 -15 15.5t-43 25t-69 15.5q-68 0 -111 -47.5t-43 -117.5t43 -117.5t111 -47.5q25 0 48.5 7 t38.5 16.5t26.5 19t16.5 16.5zM268 702l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 663,
    d: "M635 605l-58 -55q-3 3 -8 8.5t-23 20t-38.5 25t-54 19.5t-69.5 9q-111 0 -183.5 -83.5t-72.5 -198.5t72.5 -198.5t183.5 -83.5q36 0 69.5 9.5t56.5 23.5t41 27.5t27 23.5l8 9l57 -58q-4 -5 -11.5 -12.5t-32.5 -27.5t-53 -35t-72 -27.5t-90 -12.5q-150 0 -248 104.5 t-98 257.5t98 257.5t248 104.5q73 0 135.5 -27t88.5 -53zM313 828q0 23 16.5 40t39.5 17t40 -17t17 -40t-17 -39.5t-40 -16.5t-39.5 16.5t-16.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 477,
    d: "M405 132l54 -55q-3 -4 -8 -10t-23.5 -21t-38.5 -27t-52.5 -21.5t-66.5 -9.5q-102 0 -170 70t-68 173q0 102 68.5 172.5t169.5 70.5q52 0 98 -21t66 -41l20 -21l-57 -51q-5 6 -15 15.5t-43 25t-69 15.5q-68 0 -111 -47.5t-43 -117.5t43 -117.5t111 -47.5q25 0 48.5 7 t38.5 16.5t26.5 19t16.5 16.5zM207 610q0 23 16.5 40t39.5 17t40 -17t17 -40t-17 -39.5t-40 -16.5t-39.5 16.5t-16.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 663,
    d: "M635 605l-58 -55q-3 3 -8 8.5t-23 20t-38.5 25t-54 19.5t-69.5 9q-111 0 -183.5 -83.5t-72.5 -198.5t72.5 -198.5t183.5 -83.5q36 0 69.5 9.5t56.5 23.5t41 27.5t27 23.5l8 9l57 -58q-4 -5 -11.5 -12.5t-32.5 -27.5t-53 -35t-72 -27.5t-90 -12.5q-150 0 -248 104.5 t-98 257.5t98 257.5t248 104.5q73 0 135.5 -27t88.5 -53zM548 870l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 477,
    d: "M405 132l54 -55q-3 -4 -8 -10t-23.5 -21t-38.5 -27t-52.5 -21.5t-66.5 -9.5q-102 0 -170 70t-68 173q0 102 68.5 172.5t169.5 70.5q52 0 98 -21t66 -41l20 -21l-57 -51q-5 6 -15 15.5t-43 25t-69 15.5q-68 0 -111 -47.5t-43 -117.5t43 -117.5t111 -47.5q25 0 48.5 7 t38.5 16.5t26.5 19t16.5 16.5zM423 646l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 667,
    d: "M283 700q160 0 253 -97.5t93 -252.5t-93 -252.5t-253 -97.5h-201v700h201zM278 80q124 0 192.5 76.5t68.5 193.5t-68.5 193.5t-192.5 76.5h-112v-540h112zM478 867l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 647,
    d: "M256 474q29 0 54.5 -7t42 -17t29 -20.5t18.5 -17.5l5 -7v351h84v-756h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30 -24t-44 -19t-59 -8.5q-94 0 -159 70.5t-65 172.5t65 172.5t159 70.5zM405 146v170q-2 3 -5.5 8.5t-16 19.5t-27 24.5t-38 19t-49.5 8.5q-68 0 -110.5 -47.5 t-42.5 -117.5t42 -117.5t111 -47.5q26 0 49.5 8t38.5 20t26.5 24t16.5 20zM559 462v238h70v-238h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 672,
    d: "M12 326v70h85v304h191q151 0 248.5 -99t97.5 -251t-97.5 -251t-248.5 -99h-191v326h-85zM288 80q112 0 184 78t72 192t-72 192t-184 78h-107v-224h203v-70h-203v-246h107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 588,
    d: "M405 636v120h84v-120h85v-70h-85v-566h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30 -24t-44 -19t-59 -8.5q-94 0 -159 70.5t-65 172.5t65 172.5t159 70.5q29 0 54.5 -7t42 -17t29 -20.5t18.5 -17.5l5 -7v161h-163v70h163zM405 146v170q-2 3 -5.5 8.5t-16 19.5t-27 24.5t-38 19 t-49.5 8.5q-68 0 -110.5 -47.5t-42.5 -117.5t42 -117.5t111 -47.5q26 0 49.5 8t38.5 20t26.5 24t16.5 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 544,
    d: "M166 620v-221h296v-80h-296v-239h326v-80h-410v700h404v-80h-320zM136 790v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 520,
    d: "M263 474q98 0 161.5 -68t63.5 -178q0 -16 -1 -27h-373q4 -54 49.5 -94.5t109.5 -40.5q40 0 75 17t50 34l14 17l53 -55q-3 -4 -8.5 -10t-24 -21.5t-39 -27.5t-53.5 -22t-67 -10q-104 0 -172.5 70t-68.5 173t64.5 173t166.5 70zM116 271h290q-3 45 -41 85t-102 40 q-67 0 -104 -39.5t-43 -85.5zM119 572v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 544,
    d: "M166 620v-221h296v-80h-296v-239h326v-80h-410v700h404v-80h-320zM136 908h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t21.5 41.5l1 20h75q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 520,
    d: "M263 474q98 0 161.5 -68t63.5 -178q0 -16 -1 -27h-373q4 -54 49.5 -94.5t109.5 -40.5q40 0 75 17t50 34l14 17l53 -55q-3 -4 -8.5 -10t-24 -21.5t-39 -27.5t-53.5 -22t-67 -10q-104 0 -172.5 70t-68.5 173t64.5 173t166.5 70zM116 271h290q-3 45 -41 85t-102 40 q-67 0 -104 -39.5t-43 -85.5zM111 700h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t20.5 41.5l2 20h75q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 544,
    d: "M166 620v-221h296v-80h-296v-239h326v-80h-410v700h404v-80h-320zM226 828q0 23 16.5 40t39.5 17t40 -17t17 -40t-17 -39.5t-40 -16.5t-39.5 16.5t-16.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 520,
    d: "M263 474q98 0 161.5 -68t63.5 -178q0 -16 -1 -27h-373q4 -54 49.5 -94.5t109.5 -40.5q40 0 75 17t50 34l14 17l53 -55q-3 -4 -8.5 -10t-24 -21.5t-39 -27.5t-53.5 -22t-67 -10q-104 0 -172.5 70t-68.5 173t64.5 173t166.5 70zM116 271h290q-3 45 -41 85t-102 40 q-67 0 -104 -39.5t-43 -85.5zM204 610q0 23 16.5 40t39.5 17t40 -17t17 -40t-17 -39.5t-40 -16.5t-39.5 16.5t-16.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 544,
    d: "M166 620v-221h296v-80h-296v-239h326v-80h-410v700h404v-80h-320zM492 -121v-69q-18 -7 -46 -7q-47 0 -77 29t-30 71q0 31 19 55.5t38 33.5l19 8h77q-10 -3 -24.5 -9t-38.5 -27t-24 -45q0 -22 14.5 -34.5t36.5 -12.5q10 0 19 2t13 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 520,
    d: "M348 -121v-69q-18 -7 -46 -7q-47 0 -77 29t-30 71q0 54 54 87q-96 8 -156.5 76t-60.5 165q0 103 64.5 173t166.5 70q98 0 161.5 -68t63.5 -178q0 -16 -1 -27h-373q4 -54 49.5 -94.5t109.5 -40.5q40 0 75 17t50 34l14 17l53 -55q-5 -6 -14.5 -16t-41 -31.5t-65.5 -32.5 q-83 -32 -83 -80q0 -22 14.5 -34.5t36.5 -12.5q10 0 19 2t13 4zM116 271h290q-3 45 -41 85t-102 40q-67 0 -104 -39.5t-43 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 544,
    d: "M166 620v-221h296v-80h-296v-239h326v-80h-410v700h404v-80h-320zM458 867l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 520,
    d: "M263 474q98 0 161.5 -68t63.5 -178q0 -16 -1 -27h-373q4 -54 49.5 -94.5t109.5 -40.5q40 0 75 17t50 34l14 17l53 -55q-3 -4 -8.5 -10t-24 -21.5t-39 -27.5t-53.5 -22t-67 -10q-104 0 -172.5 70t-68.5 173t64.5 173t166.5 70zM116 271h290q-3 45 -41 85t-102 40 q-67 0 -104 -39.5t-43 -85.5zM432 646l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 717,
    d: "M403 304v80h258v-304q-4 -4 -11 -10t-33 -22t-55.5 -28t-77 -22t-98.5 -10q-150 0 -249 104.5t-99 257.5t99 257.5t249 104.5q51 0 96 -10t73 -25t48.5 -29.5t29.5 -24.5l9 -10l-60 -59q-3 3 -8 8.5t-23.5 19t-39.5 23.5t-55 18.5t-70 8.5q-111 0 -184.5 -83.5 t-73.5 -198.5t73.5 -198.5t184.5 -83.5q57 0 105 13t67 25l20 13v185h-175zM390 922l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 553,
    d: "M405 -6v64q-11 -15 -26.5 -28.5t-49.5 -27.5t-73 -14q-94 0 -159 70.5t-65 172.5t65 172.5t159 70.5q49 0 88 -20t54 -40l14 -19v67h77v-464q0 -115 -68.5 -177.5t-174.5 -62.5q-56 0 -106.5 22t-73.5 44l-22 22l51 63q2 -3 6.5 -8t19.5 -17.5t31 -22t41.5 -17.5t52.5 -8 q75 0 117 40.5t42 117.5zM405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38.5 18.5t-49 8.5q-69 0 -111 -47.5t-42 -117.5t42 -117.5t111 -47.5q26 0 49.5 8t38.5 19.5t26.5 23t16.5 19.5zM276 702l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 717,
    d: "M403 304v80h258v-304q-4 -4 -11 -10t-33 -22t-55.5 -28t-77 -22t-98.5 -10q-150 0 -249 104.5t-99 257.5t99 257.5t249 104.5q51 0 96 -10t73 -25t48.5 -29.5t29.5 -24.5l9 -10l-60 -59q-3 3 -8 8.5t-23.5 19t-39.5 23.5t-55 18.5t-70 8.5q-111 0 -184.5 -83.5 t-73.5 -198.5t73.5 -198.5t184.5 -83.5q57 0 105 13t67 25l20 13v185h-175zM225 908h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t20.5 41.5l2 20h75q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 553,
    d: "M405 -6v64q-11 -15 -26.5 -28.5t-49.5 -27.5t-73 -14q-94 0 -159 70.5t-65 172.5t65 172.5t159 70.5q49 0 88 -20t54 -40l14 -19v67h77v-464q0 -115 -68.5 -177.5t-174.5 -62.5q-56 0 -106.5 22t-73.5 44l-22 22l51 63q2 -3 6.5 -8t19.5 -17.5t31 -22t41.5 -17.5t52.5 -8 q75 0 117 40.5t42 117.5zM405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38.5 18.5t-49 8.5q-69 0 -111 -47.5t-42 -117.5t42 -117.5t111 -47.5q26 0 49.5 8t38.5 19.5t26.5 23t16.5 19.5zM120 700h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t21.5 41.5l1 20h75 q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 717,
    d: "M403 304v80h258v-304q-4 -4 -11 -10t-33 -22t-55.5 -28t-77 -22t-98.5 -10q-150 0 -249 104.5t-99 257.5t99 257.5t249 104.5q51 0 96 -10t73 -25t48.5 -29.5t29.5 -24.5l9 -10l-60 -59q-3 3 -8 8.5t-23.5 19t-39.5 23.5t-55 18.5t-70 8.5q-111 0 -184.5 -83.5 t-73.5 -198.5t73.5 -198.5t184.5 -83.5q57 0 105 13t67 25l20 13v185h-175zM322 828q0 23 16.5 40t39.5 17t40 -17t17 -40t-17 -39.5t-40 -16.5t-39.5 16.5t-16.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 553,
    d: "M405 -6v64q-11 -15 -26.5 -28.5t-49.5 -27.5t-73 -14q-94 0 -159 70.5t-65 172.5t65 172.5t159 70.5q49 0 88 -20t54 -40l14 -19v67h77v-464q0 -115 -68.5 -177.5t-174.5 -62.5q-56 0 -106.5 22t-73.5 44l-22 22l51 63q2 -3 6.5 -8t19.5 -17.5t31 -22t41.5 -17.5t52.5 -8 q75 0 117 40.5t42 117.5zM405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38.5 18.5t-49 8.5q-69 0 -111 -47.5t-42 -117.5t42 -117.5t111 -47.5q26 0 49.5 8t38.5 19.5t26.5 23t16.5 19.5zM220 610q0 23 16.5 40t39.5 17t40 -17t17 -40t-17 -39.5t-40 -16.5t-39.5 16.5 t-16.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcedilla",
    unicode: "\u0122",
    horizAdvX: 717,
    d: "M403 304v80h258v-304q-4 -4 -11 -10t-33 -22t-55.5 -28t-77 -22t-98.5 -10q-150 0 -249 104.5t-99 257.5t99 257.5t249 104.5q51 0 96 -10t73 -25t48.5 -29.5t29.5 -24.5l9 -10l-60 -59q-3 3 -8 8.5t-23.5 19t-39.5 23.5t-55 18.5t-70 8.5q-111 0 -184.5 -83.5 t-73.5 -198.5t73.5 -198.5t184.5 -83.5q57 0 105 13t67 25l20 13v185h-175zM427 -56l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcedilla",
    unicode: "\u0123",
    horizAdvX: 553,
    d: "M405 -6v64q-11 -15 -26.5 -28.5t-49.5 -27.5t-73 -14q-94 0 -159 70.5t-65 172.5t65 172.5t159 70.5q49 0 88 -20t54 -40l14 -19v67h77v-464q0 -115 -68.5 -177.5t-174.5 -62.5q-56 0 -106.5 22t-73.5 44l-22 22l51 63q2 -3 6.5 -8t19.5 -17.5t31 -22t41.5 -17.5t52.5 -8 q75 0 117 40.5t42 117.5zM405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38.5 18.5t-49 8.5q-69 0 -111 -47.5t-42 -117.5t42 -117.5t111 -47.5q26 0 49.5 8t38.5 19.5t26.5 23t16.5 19.5zM223 533l59 198l80 -24l-62 -183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 683,
    d: "M517 399v301h84v-700h-84v319h-351v-319h-84v700h84v-301h351zM342 919l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 535,
    d: "M297 474q73 0 123.5 -47.5t50.5 -129.5v-297h-84v283q0 56 -31 84.5t-80 28.5q-21 0 -40.5 -8t-32.5 -19.5t-23 -23t-14 -19.5l-5 -8v-318h-84v756h84v-350q48 68 136 68zM120 962l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 701,
    d: "M91 580v120h84v-120h351v120h84v-120h83v-70h-83v-510h-84v319h-351v-319h-84v510h-83v70h83zM175 510v-111h351v111h-351z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 559,
    d: "M8 570v70h91v116h84v-116h163v-70h-163v-166q2 3 5.5 7.5t16 16.5t27 21.5t38.5 17t51 7.5q73 0 123.5 -47.5t50.5 -129.5v-297h-84v279q0 57 -31 87t-80 30q-22 0 -42.5 -8t-33.5 -19.5t-22.5 -23t-13.5 -19.5l-5 -8v-318h-84v570h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 276,
    d: "M109 0v700h84v-700h-84zM39 781l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9q28 0 64 -22.5t48 -22.5q19 0 33 12.5t19 24.5l5 13l58 -37l-3 -9t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5t-48 22.5q-19 0 -33.5 -12.5t-18.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 278,
    d: "M97 0v462h84v-462h-84zM27 543l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9q28 0 64 -22.5t48 -22.5q19 0 33 12.5t19 24.5l5 13l58 -37l-3 -9t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5t-48 22.5q-19 0 -33.5 -12.5t-18.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 276,
    d: "M96 0v700h84v-700h-84zM-13 790v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 254,
    d: "M84 0v462h84v-462h-84zM-24 572v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 276,
    d: "M96 0v700h84v-700h-84zM-16 908h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t21.5 41.5l1 20h75q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 290,
    d: "M101 0v462h84v-462h-84zM-9 700h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t20.5 41.5l2 20h75q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 276,
    d: "M179 -121v-69q-18 -7 -46 -7q-47 0 -77 29.5t-30 72.5q0 42 23.5 67.5t46.5 34.5v693h84v-700h-2q-7 -2 -16 -5t-27.5 -12.5t-30.5 -25.5t-12 -36q0 -23 14.5 -36t36.5 -13q10 0 19 2t13 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 249,
    d: "M169 -121v-69q-18 -7 -46 -7q-47 0 -77 29.5t-30 72.5q0 42 23.5 67.5t46.5 34.5v455h84v-462h-2q-7 -2 -16 -5t-27.5 -12.5t-30.5 -25.5t-12 -36q0 -23 14.5 -36t36.5 -13q10 0 19 2t13 4zM71 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 276,
    d: "M96 0v700h84v-700h-84zM81 838q0 23 16.5 40t39.5 17t40 -17t17 -40t-17 -39.5t-40 -16.5t-39.5 16.5t-16.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 220,
    d: "M68 0v462h84v-462h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 688,
    d: "M96 0v700h84v-700h-84zM522 186v514h84v-513q0 -89 -55.5 -144t-150.5 -55q-32 0 -63 10.5t-51.5 25t-36.5 29.5t-23 25l-8 11l61 53q5 -8 14 -20.5t40.5 -33t66.5 -20.5q64 0 93 35t29 83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 459,
    d: "M79 0v462h84v-462h-84zM64 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM178 -221l30 70q23 -13 35 -13q15 0 25 3.5t19 20.5t9 47v555h84v-563q0 -74 -38.5 -107.5t-85.5 -33.5q-42 0 -78 21zM281 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40 t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 500,
    d: "M308 186v514h84v-513q0 -89 -55.5 -144t-150.5 -55q-32 0 -63 10.5t-51.5 25t-36.5 29.5t-23 25l-8 11l61 53q5 -8 14 -20.5t40.5 -33t66.5 -20.5q64 0 93 35t29 83zM350 922l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 268,
    d: "M-20 -221l30 70q23 -13 35 -13q15 0 25 3.5t19 20.5t9 47v555h84v-563q0 -74 -38.5 -107.5t-85.5 -33.5q-42 0 -78 21zM140 702l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcedilla",
    unicode: "\u0136",
    horizAdvX: 589,
    d: "M166 700v-329l283 329h107l-296 -342l329 -358h-114l-309 334v-334h-84v700h84zM362 -46l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcedilla",
    unicode: "\u0137",
    horizAdvX: 494,
    d: "M375 0l-209 224v-224h-84v756h84v-499l198 205h110l-216 -218l234 -244h-117zM306 -56l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 476,
    d: "M361 0l-213 224v-224h-84v462h84v-201l196 201h109l-213 -218l234 -244h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 486,
    d: "M80 0v700h84v-620h314v-80h-398zM209 939l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 247,
    d: "M82 0v756h84v-756h-84zM211 991l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcedilla",
    unicode: "\u013B",
    horizAdvX: 488,
    d: "M82 0v700h84v-620h314v-80h-398zM323 -56l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcedilla",
    unicode: "\u013C",
    horizAdvX: 247,
    d: "M82 0v756h84v-756h-84zM176 -56l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 488,
    d: "M82 0v700h84v-620h314v-80h-398zM269 462v238h70v-238h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 323,
    d: "M82 0v756h84v-756h-84zM235 462v238h70v-238h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 488,
    d: "M366 360q0 -23 -17 -40t-39 -17t-39.5 17.5t-17.5 39.5t17 39t40 17q22 0 39 -17t17 -39zM82 0v700h84v-620h314v-80h-398z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 361,
    d: "M333 360q0 -23 -17 -40t-39 -17q-23 0 -40 17.5t-17 39.5t17 39t40 17t39.5 -17t16.5 -39zM82 0v756h84v-756h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 520,
    d: "M50 180l-42 57l107 83v380h84v-314l165 128l42 -57l-207 -161v-216h311v-80h-395v230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 334,
    d: "M52 228l-42 57l113 88v383h84v-318l78 61l42 -57l-120 -93v-349h-84v283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 710,
    d: "M82 700h87l375 -560v560h84v-700h-87l-375 560v-560h-84v700zM456 939l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 522,
    d: "M284 474q73 0 123.5 -47.5t50.5 -129.5v-297h-84v283q0 56 -31 84.5t-80 28.5q-21 0 -40.5 -8t-32.5 -19.5t-23 -23t-15 -19.5l-4 -8v-318h-84v462h78v-65q2 3 5.5 8.5t16 18.5t27.5 23t40 18.5t53 8.5zM314 722l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncedilla",
    unicode: "\u0145",
    horizAdvX: 710,
    d: "M82 700h87l375 -560v560h84v-700h-87l-375 560v-560h-84v700zM394 -46l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncedilla",
    unicode: "\u0146",
    horizAdvX: 522,
    d: "M284 474q73 0 123.5 -47.5t50.5 -129.5v-297h-84v283q0 56 -31 84.5t-80 28.5q-21 0 -40.5 -8t-32.5 -19.5t-23 -23t-15 -19.5l-4 -8v-318h-84v462h78v-65q2 3 5.5 8.5t16 18.5t27.5 23t40 18.5t53 8.5zM314 -46l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 710,
    d: "M82 700h87l375 -560v560h84v-700h-87l-375 560v-560h-84v700zM533 877l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 522,
    d: "M284 474q73 0 123.5 -47.5t50.5 -129.5v-297h-84v283q0 56 -31 84.5t-80 28.5q-21 0 -40.5 -8t-32.5 -19.5t-23 -23t-15 -19.5l-4 -8v-318h-84v462h78v-65q2 3 5.5 8.5t16 18.5t27.5 23t40 18.5t53 8.5zM431 656l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 588,
    d: "M350 474q73 0 123.5 -47.5t50.5 -129.5v-297h-84v283q0 56 -31 84.5t-80 28.5q-21 0 -40.5 -8t-32.5 -19.5t-23 -23t-15 -19.5l-4 -8v-318h-84v462h78v-65q2 3 5.5 8.5t16 18.5t27.5 23t40 18.5t53 8.5zM18 462v238h70v-238h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 710,
    d: "M426 -221l30 70q23 -13 35 -13q15 0 25 3.5t19 20.5t9 47v93l-378 558v-558h-84v700h84l378 -558v558h84v-801q0 -74 -38.5 -107.5t-85.5 -33.5q-42 0 -78 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 522,
    d: "M284 474q73 0 123.5 -47.5t50.5 -129.5v-398q0 -74 -38.5 -107.5t-85.5 -33.5q-42 0 -78 21l30 70q23 -13 35 -13q15 0 25 3.5t19 20.5t9 47v372q0 57 -31 87t-80 30q-22 0 -42.5 -8t-33 -19.5t-22 -23t-13.5 -19.5l-4 -8v-318h-84v462h78v-65q2 3 5.5 8.5t16 18.5 t27.5 23t40 18.5t53 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 768,
    d: "M384 712q150 0 248 -104.5t98 -257.5t-98 -257.5t-248 -104.5t-248 104.5t-98 257.5t98 257.5t248 104.5zM384 68q112 0 184 83.5t72 198.5t-72 198.5t-184 83.5t-184 -83.5t-72 -198.5t72 -198.5t184 -83.5zM233 800v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 540,
    d: "M270 474q102 0 170 -70t68 -173t-68 -173t-170 -70t-170 70t-68 173t68 173t170 70zM270 66q68 0 111 47.5t43 117.5t-43 117.5t-111 47.5t-111 -47.5t-43 -117.5t43 -117.5t111 -47.5zM119 572v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 768,
    d: "M384 712q150 0 248 -104.5t98 -257.5t-98 -257.5t-248 -104.5t-248 104.5t-98 257.5t98 257.5t248 104.5zM384 68q112 0 184 83.5t72 198.5t-72 198.5t-184 83.5t-184 -83.5t-72 -198.5t72 -198.5t184 -83.5zM230 908h75v-8.5t4 -20t11 -25t24 -19.5t40 -9 q37 0 56.5 20.5t21.5 41.5l1 20h75q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 540,
    d: "M270 474q102 0 170 -70t68 -173t-68 -173t-170 -70t-170 70t-68 173t68 173t170 70zM270 66q68 0 111 47.5t43 117.5t-43 117.5t-111 47.5t-111 -47.5t-43 -117.5t43 -117.5t111 -47.5zM116 700h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t21.5 41.5l1 20h75 q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 768,
    d: "M384 712q150 0 248 -104.5t98 -257.5t-98 -257.5t-248 -104.5t-248 104.5t-98 257.5t98 257.5t248 104.5zM384 68q112 0 184 83.5t72 198.5t-72 198.5t-184 83.5t-184 -83.5t-72 -198.5t72 -198.5t184 -83.5zM537 964l64 -40l-121 -170l-59 36zM375 964l64 -40l-121 -170 l-59 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 540,
    d: "M270 474q102 0 170 -70t68 -173t-68 -173t-170 -70t-170 70t-68 173t68 173t170 70zM270 66q68 0 111 47.5t43 117.5t-43 117.5t-111 47.5t-111 -47.5t-43 -117.5t43 -117.5t111 -47.5zM417 726l64 -40l-121 -170l-59 36zM255 726l64 -40l-121 -170l-59 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 836,
    d: "M384 0q-151 0 -248.5 99t-97.5 251t97.5 251t248.5 99h394v-80h-280v-221h256v-80h-256v-239h286v-80h-400zM384 620q-113 0 -186.5 -78.5t-73.5 -191.5t73.5 -191.5t186.5 -78.5h30v540h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 902,
    d: "M650 474q96 0 158 -67.5t62 -178.5q0 -16 -1 -27h-363q2 -54 47 -94.5t106 -40.5q41 0 78 19t61 50l52 -54q-34 -41 -85.5 -67t-105.5 -26q-61 0 -111.5 27t-82.5 74q-32 -47 -83.5 -74t-111.5 -27q-102 0 -170 70t-68 173t68 173t170 70q60 0 110.5 -27t82.5 -74 q65 101 187 101zM270 66q66 0 109 45.5t45 112.5v7q0 70 -43 117.5t-111 47.5t-111 -47.5t-43 -117.5t43 -117.5t111 -47.5zM508 270h279q-2 46 -37.5 86t-99.5 40q-63 0 -101 -41t-41 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 553,
    d: "M269 366q69 0 107 34t38 93t-38 93t-107 34h-103v-254h103zM82 0v700h182q105 0 169.5 -57t64.5 -150q0 -47 -16.5 -84t-37.5 -57.5t-48.5 -34.5t-42.5 -18t-26 -6l194 -293h-101l-189 286h-65v-286h-84zM363 939l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 340,
    d: "M271 474q17 0 33.5 -3t25.5 -6l8 -3l-31 -76q-18 10 -53 10q-32 0 -58.5 -19.5t-37.5 -38.5l-10 -20v-318h-84v462h78v-71q2 3 5 9t15 20t25.5 25t36 20t47.5 9zM237 722l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcedilla",
    unicode: "\u0156",
    horizAdvX: 553,
    d: "M269 366q69 0 107 34t38 93t-38 93t-107 34h-103v-254h103zM82 0v700h182q105 0 169.5 -57t64.5 -150q0 -47 -16.5 -84t-37.5 -57.5t-48.5 -34.5t-42.5 -18t-26 -6l194 -293h-101l-189 286h-65v-286h-84zM343 -46l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcedilla",
    unicode: "\u0157",
    horizAdvX: 340,
    d: "M271 474q17 0 33.5 -3t25.5 -6l8 -3l-31 -76q-18 10 -53 10q-32 0 -58.5 -19.5t-37.5 -38.5l-10 -20v-318h-84v462h78v-71q2 3 5 9t15 20t25.5 25t36 20t47.5 9zM171 -56l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 553,
    d: "M269 366q69 0 107 34t38 93t-38 93t-107 34h-103v-254h103zM82 0v700h182q105 0 169.5 -57t64.5 -150q0 -47 -16.5 -84t-37.5 -57.5t-48.5 -34.5t-42.5 -18t-26 -6l194 -293h-101l-189 286h-65v-286h-84zM440 867l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 340,
    d: "M271 474q17 0 33.5 -3t25.5 -6l8 -3l-31 -76q-18 10 -53 10q-32 0 -58.5 -19.5t-37.5 -38.5l-10 -20v-318h-84v462h78v-71q2 3 5 9t15 20t25.5 25t36 20t47.5 9zM359 646l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 542,
    d: "M404 178q0 26 -9 46t-31 37t-40.5 27t-55.5 27t-60 29t-51 32t-43.5 39.5t-26.5 48.5t-11 64q0 69 54.5 126.5t147.5 57.5q37 0 71 -10.5t56.5 -25.5t39.5 -30t25 -26l7 -10l-63 -51q-2 3 -6 8t-17 17.5t-27.5 22t-38 17.5t-47.5 8q-54 0 -86 -31.5t-32 -72.5 q0 -26 9.5 -45.5t34 -37t46 -28.5t66.5 -32t73 -38t53 -41t36.5 -55.5t11.5 -72.5q0 -84 -61.5 -137t-155.5 -53q-46 0 -86.5 15t-64.5 36.5t-41 43t-24 36.5l-7 15l70 42q2 -4 5.5 -11.5t16.5 -26t29 -33t43.5 -26t58.5 -11.5q54 0 92.5 29.5t38.5 80.5zM349 949l52 -52 l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 455,
    d: "M34 85l58 54q2 -3 6 -8t17 -18t28 -23t39.5 -18t49.5 -8q39 0 69.5 15.5t30.5 41.5q0 29 -25 46t-80 28q-81 16 -125 50.5t-44 95.5q0 53 48 93t122 40q48 0 91 -17.5t61 -34.5l19 -18l-55 -57q-5 6 -14.5 14.5t-40 22.5t-61.5 14q-42 0 -65 -17.5t-23 -41.5 q0 -26 26.5 -42t85.5 -28q77 -17 120 -49t43 -97q0 -63 -55 -99t-128 -36q-36 0 -70 10t-56 24.5t-39 28.5t-25 24zM295 721l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 542,
    d: "M404 178q0 26 -9 46t-31 37t-40.5 27t-55.5 27t-60 29t-51 32t-43.5 39.5t-26.5 48.5t-11 64q0 69 54.5 126.5t147.5 57.5q37 0 71 -10.5t56.5 -25.5t39.5 -30t25 -26l7 -10l-63 -51q-2 3 -6 8t-17 17.5t-27.5 22t-38 17.5t-47.5 8q-54 0 -86 -31.5t-32 -72.5 q0 -26 9.5 -45.5t34 -37t46 -28.5t66.5 -32t73 -38t53 -41t36.5 -55.5t11.5 -72.5q0 -84 -61.5 -137t-155.5 -53q-46 0 -86.5 15t-64.5 36.5t-41 43t-24 36.5l-7 15l70 42q2 -4 5.5 -11.5t16.5 -26t29 -33t43.5 -26t58.5 -11.5q54 0 92.5 29.5t38.5 80.5zM285 920l166 -121 l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 455,
    d: "M34 85l58 54q2 -3 6 -8t17 -18t28 -23t39.5 -18t49.5 -8q39 0 69.5 15.5t30.5 41.5q0 29 -25 46t-80 28q-81 16 -125 50.5t-44 95.5q0 53 48 93t122 40q48 0 91 -17.5t61 -34.5l19 -18l-55 -57q-5 6 -14.5 14.5t-40 22.5t-61.5 14q-42 0 -65 -17.5t-23 -41.5 q0 -26 26.5 -42t85.5 -28q77 -17 120 -49t43 -97q0 -63 -55 -99t-128 -36q-36 0 -70 10t-56 24.5t-39 28.5t-25 24zM238 702l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 542,
    d: "M404 178q0 26 -9 46t-31 37t-40.5 27t-55.5 27t-60 29t-51 32t-43.5 39.5t-26.5 48.5t-11 64q0 69 54.5 126.5t147.5 57.5q37 0 71 -10.5t56.5 -25.5t39.5 -30t25 -26l7 -10l-63 -51q-2 3 -6 8t-17 17.5t-27.5 22t-38 17.5t-47.5 8q-54 0 -86 -31.5t-32 -72.5 q0 -26 9.5 -45.5t34 -37t46 -28.5t66.5 -32t73 -38t53 -41t36.5 -55.5t11.5 -72.5q0 -84 -61.5 -137t-155.5 -53q-46 0 -86.5 15t-64.5 36.5t-41 43t-24 36.5l-7 15l70 42q2 -4 5.5 -11.5t16.5 -26t29 -33t43.5 -26t58.5 -11.5q54 0 92.5 29.5t38.5 80.5zM314 -56l-59 -198 l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 455,
    d: "M34 85l58 54q2 -3 6 -8t17 -18t28 -23t39.5 -18t49.5 -8q39 0 69.5 15.5t30.5 41.5q0 29 -25 46t-80 28q-81 16 -125 50.5t-44 95.5q0 53 48 93t122 40q48 0 91 -17.5t61 -34.5l19 -18l-55 -57q-5 6 -14.5 14.5t-40 22.5t-61.5 14q-42 0 -65 -17.5t-23 -41.5 q0 -26 26.5 -42t85.5 -28q77 -17 120 -49t43 -97q0 -63 -55 -99t-128 -36q-36 0 -70 10t-56 24.5t-39 28.5t-25 24zM269 -56l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 542,
    d: "M404 178q0 26 -9 46t-31 37t-40.5 27t-55.5 27t-60 29t-51 32t-43.5 39.5t-26.5 48.5t-11 64q0 69 54.5 126.5t147.5 57.5q37 0 71 -10.5t56.5 -25.5t39.5 -30t25 -26l7 -10l-63 -51q-2 3 -6 8t-17 17.5t-27.5 22t-38 17.5t-47.5 8q-54 0 -86 -31.5t-32 -72.5 q0 -26 9.5 -45.5t34 -37t46 -28.5t66.5 -32t73 -38t53 -41t36.5 -55.5t11.5 -72.5q0 -84 -61.5 -137t-155.5 -53q-46 0 -86.5 15t-64.5 36.5t-41 43t-24 36.5l-7 15l70 42q2 -4 5.5 -11.5t16.5 -26t29 -33t43.5 -26t58.5 -11.5q54 0 92.5 29.5t38.5 80.5zM451 867l-166 -121 l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 455,
    d: "M33 85l58 54q2 -3 6 -8t17 -18t28 -23t39.5 -18t49.5 -8q39 0 69.5 15.5t30.5 41.5q0 29 -25 46t-80 28q-81 16 -125 50.5t-44 95.5q0 53 48 93t122 40q48 0 91 -17.5t62 -34.5l18 -18l-55 -57q-5 6 -14.5 14.5t-40 22.5t-61.5 14q-42 0 -65 -17.5t-23 -41.5 q0 -26 26.5 -42t85.5 -28q77 -17 120 -49t43 -97q0 -63 -55 -99t-128 -36q-36 0 -70 10t-56 24.5t-39 28.5t-25 24zM405 646l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcedilla",
    unicode: "\u0162",
    horizAdvX: 514,
    d: "M215 0v620h-201v80h486v-80h-201v-620h-84zM300 -56l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcedilla",
    unicode: "\u0163",
    horizAdvX: 376,
    d: "M24 386v76h90v141h84v-141h144v-76h-144v-249q0 -71 67 -71q12 0 25 5t20 9l8 5l31 -69q-51 -28 -96 -28q-56 0 -97.5 37t-41.5 108v253h-90zM254 -56l-59 -198l-80 24l62 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 514,
    d: "M215 0v620h-201v80h486v-80h-201v-620h-84zM423 868l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 376,
    d: "M24 386v76h90v141h84v-141h144v-76h-144v-249q0 -71 67 -71q12 0 25 5t20 9l8 5l31 -69q-51 -28 -96 -28q-56 0 -97.5 37t-41.5 108v253h-90zM271 518v238h70v-238h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 514,
    d: "M64 392v70h151v158h-201v80h486v-80h-201v-158h151v-70h-151v-392h-84v392h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 374,
    d: "M24 388v74h84v141h84v-141h144v-74h-144v-88h144v-70h-144v-90q0 -34 18.5 -54t51.5 -20q12 0 25.5 5t20.5 9l8 5l31 -69q-51 -28 -97 -28q-55 0 -98.5 39t-43.5 108v95h-84v70h84v88h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 674,
    d: "M508 267v433h84v-442q0 -121 -68.5 -195.5t-186.5 -74.5t-186.5 74.5t-68.5 195.5v442h84v-433q0 -90 42 -144.5t129 -54.5t129 54.5t42 144.5zM225 791l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9q28 0 64 -22.5t48 -22.5q19 0 33 12.5t19 24.5l5 13l58 -37l-3 -9 t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5t-48 22.5q-19 0 -33.5 -12.5t-18.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 522,
    d: "M238 -12q-73 0 -123.5 47.5t-50.5 129.5v297h84v-283q0 -56 31 -84.5t80 -28.5q35 0 63.5 19t39.5 38l12 19v320h84v-462h-78v71q-2 -3 -5.5 -9t-16 -20t-27.5 -25t-40 -20t-53 -9zM149 553l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9q28 0 64 -22.5t48 -22.5 q19 0 33 12.5t19 24.5l5 13l58 -37l-3 -9t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5t-48 22.5q-19 0 -33.5 -12.5t-18.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 674,
    d: "M508 267v433h84v-442q0 -121 -68.5 -195.5t-186.5 -74.5t-186.5 74.5t-68.5 195.5v442h84v-433q0 -90 42 -144.5t129 -54.5t129 54.5t42 144.5zM186 790v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 522,
    d: "M238 -12q-73 0 -123.5 47.5t-50.5 129.5v297h84v-283q0 -56 31 -84.5t80 -28.5q35 0 63.5 19t39.5 38l12 19v320h84v-462h-78v71q-2 -3 -5.5 -9t-16 -20t-27.5 -25t-40 -20t-53 -9zM111 572v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 674,
    d: "M508 267v433h84v-442q0 -121 -68.5 -195.5t-186.5 -74.5t-186.5 74.5t-68.5 195.5v442h84v-433q0 -90 42 -144.5t129 -54.5t129 54.5t42 144.5zM184 908h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t21.5 41.5l1 20h75q0 -6 -1 -16t-10 -36t-23.5 -45.5 t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 522,
    d: "M238 -12q-73 0 -123.5 47.5t-50.5 129.5v297h84v-283q0 -56 31 -84.5t80 -28.5q35 0 63.5 19t39.5 38l12 19v320h84v-462h-78v71q-2 -3 -5.5 -9t-16 -20t-27.5 -25t-40 -20t-53 -9zM106 700h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t21.5 41.5l1 20h75 q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 674,
    d: "M508 267v433h84v-442q0 -121 -68.5 -195.5t-186.5 -74.5t-186.5 74.5t-68.5 195.5v442h84v-433q0 -90 42 -144.5t129 -54.5t129 54.5t42 144.5zM283 840q0 -23 16 -39t39 -16t39 16t16 39t-16 39t-39 16t-39 -16t-16 -39zM230 840q0 45 31.5 76.5t76.5 31.5t76.5 -31.5 t31.5 -76.5t-31.5 -76.5t-76.5 -31.5t-76.5 31.5t-31.5 76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 522,
    d: "M238 -12q-73 0 -123.5 47.5t-50.5 129.5v297h84v-283q0 -56 31 -84.5t80 -28.5q35 0 63.5 19t39.5 38l12 19v320h84v-462h-78v71q-2 -3 -5.5 -9t-16 -20t-27.5 -25t-40 -20t-53 -9zM208 645q0 -23 16 -39t39 -16t39 16t16 39t-16 39t-39 16t-39 -16t-16 -39zM155 645 q0 45 31.5 76.5t76.5 31.5t76.5 -31.5t31.5 -76.5t-31.5 -76.5t-76.5 -31.5t-76.5 31.5t-31.5 76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 674,
    d: "M508 267v433h84v-442q0 -121 -68.5 -195.5t-186.5 -74.5t-186.5 74.5t-68.5 195.5v442h84v-433q0 -90 42 -144.5t129 -54.5t129 54.5t42 144.5zM474 964l64 -40l-121 -170l-59 36zM312 964l64 -40l-121 -170l-59 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 525,
    d: "M238 -12q-73 0 -123.5 47.5t-50.5 129.5v297h84v-283q0 -56 31 -84.5t80 -28.5q35 0 63.5 19t39.5 38l12 19v320h84v-462h-78v71q-2 -3 -5.5 -9t-16 -20t-27.5 -25t-40 -20t-53 -9zM397 726l64 -40l-121 -170l-59 36zM235 726l64 -40l-121 -170l-59 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 674,
    d: "M422 -121v-69q-18 -7 -46 -7q-47 0 -77 29t-30 71q0 53 52 86q-111 5 -175 78.5t-64 190.5v442h84v-433q0 -90 42 -144.5t129 -54.5t129 54.5t42 144.5v433h84v-442q0 -97 -44.5 -165t-125.5 -93q-12 -3 -28.5 -10t-37.5 -27t-21 -44q0 -22 14.5 -34.5t36.5 -12.5 q10 0 19 2t13 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 522,
    d: "M238 -12q-73 0 -123.5 47.5t-50.5 129.5v297h84v-283q0 -56 31 -84.5t80 -28.5q35 0 63.5 19t39.5 38l12 19v320h84v-462h-1q-7 -2 -16 -5t-27.5 -12.5t-30.5 -25.5t-12 -36q0 -23 14.5 -36t36.5 -13q10 0 19 2t13 4l4 1v-69q-18 -7 -46 -7q-47 0 -77 29.5t-30 72.5 q0 25 9.5 45.5t24.5 32.5t24 17t17 8v63q-2 -3 -5.5 -9t-16 -20t-27.5 -25t-40 -20t-53 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 950,
    d: "M946 700l-270 -720l-201 551l-202 -551l-269 720h94l177 -485l172 485h61l170 -485l179 485h89zM478 920l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 742,
    d: "M8 462h91l124 -299l122 299h57l123 -299l123 299h86l-211 -482l-152 347l-152 -347zM373 702l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    d: "M248 0v275l-236 425h94l188 -344l185 344h89l-236 -425v-275h-84zM290 920l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 500,
    d: "M27 -209l36 69q29 -24 55 -24t41.5 17t30.5 54l36 91l-216 464h95l162 -365l138 365h91q-232 -584 -243 -611q-19 -47 -53.5 -70t-74.5 -23q-25 0 -49.5 8t-36.5 16zM256 704l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    d: "M248 0v275l-236 425h94l188 -344l185 344h89l-236 -425v-275h-84zM143 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM324 838q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 572,
    d: "M45 700h509l-393 -620h374v-80h-517l393 620h-366v80zM376 939l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 470,
    d: "M48 462h399l-265 -384h254v-78h-402l265 384h-251v78zM323 701l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 572,
    d: "M45 700h509l-393 -620h374v-80h-517l393 620h-366v80zM240 818q0 23 16.5 40t39.5 17t40 -17t17 -40t-17 -39.5t-40 -16.5t-39.5 16.5t-16.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 470,
    d: "M48 462h399l-265 -384h254v-78h-402l265 384h-251v78zM184 610q0 23 16.5 40t39.5 17t40 -17t17 -40t-17 -39.5t-40 -16.5t-39.5 16.5t-16.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 572,
    d: "M45 700h509l-393 -620h374v-80h-517l393 620h-366v80zM464 869l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 470,
    d: "M48 462h399l-265 -384h254v-78h-402l265 384h-251v78zM412 646l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "longs",
    unicode: "\u017F",
    horizAdvX: 331,
    d: "M20 388v74h96v159q0 69 43.5 108t98.5 39q48 0 97 -27l-31 -69q-28 18 -54 18q-33 0 -51.5 -20t-18.5 -54v-616h-84v388h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    d: "M341 388l-62 -352q-31 -183 -203 -183h-36v78h34q103 0 122 110l61 347h-86l12 74h86l29 159q26 147 167 147q19 0 41 -6t34 -12l12 -7l-31 -69q-27 16 -54 16q-73 0 -86 -74l-28 -154h120l-12 -74h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophemod",
    unicode: "\u02BC",
    horizAdvX: 150,
    d: "M40 462v238h70v-238h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 424,
    d: "M212 684l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 418,
    d: "M375 641l-166 -121l-166 121l42 56l124 -95l124 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 410,
    d: "M51 700h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t20.5 41.5l2 20h75q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 239,
    d: "M63 600q0 23 16.5 40t39.5 17t40 -17t17 -40t-17 -39.5t-40 -16.5t-39.5 16.5t-16.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 242,
    d: "M66 633q0 -23 16 -39t39 -16t39 16t16 39t-16 39t-39 16t-39 -16t-16 -39zM13 633q0 45 31.5 76.5t76.5 31.5t76.5 -31.5t31.5 -76.5t-31.5 -76.5t-76.5 -31.5t-76.5 31.5t-31.5 76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 219,
    d: "M165 -121v-69q-18 -7 -46 -7q-47 0 -77 29t-30 71q0 31 19 55.5t38 33.5l19 8h77q-10 -3 -24.5 -9t-38.5 -27t-24 -45q0 -22 14.5 -34.5t36.5 -12.5q10 0 19 2t13 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 390,
    d: "M83 553l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9q28 0 64 -22.5t48 -22.5q19 0 33 12.5t19 24.5l5 13l58 -37l-3 -9t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5t-48 22.5q-19 0 -33.5 -12.5t-18.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 382,
    d: "M296 726l64 -40l-121 -170l-59 36zM134 726l64 -40l-121 -170l-59 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u0394",
    horizAdvX: 836,
    d: "M4 0l414 756l414 -756h-828zM138 75h560l-280 512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 836,
    d: "M4 0l414 756l414 -756h-828zM138 75h560l-280 512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u03A9",
    horizAdvX: 788,
    d: "M77 0v80h118q-63 38 -105 111.5t-42 158.5q0 153 98 257.5t248 104.5t248 -104.5t98 -257.5q0 -85 -42.5 -158.5t-105.5 -111.5h119v-80h-240v80q81 27 130 102t49 168q0 115 -72.5 198.5t-183.5 83.5t-183.5 -83.5t-72.5 -198.5q0 -93 49 -168t130 -102v-80h-240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 788,
    d: "M77 0v80h118q-63 38 -105 111.5t-42 158.5q0 153 98 257.5t248 104.5t248 -104.5t98 -257.5q0 -85 -42.5 -158.5t-105.5 -111.5h119v-80h-240v80q81 27 130 102t49 168q0 115 -72.5 198.5t-183.5 83.5t-183.5 -83.5t-72.5 -198.5q0 -93 49 -168t130 -102v-80h-240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 585,
    d: "M519 75l30 -70q-36 -21 -78 -21q-47 0 -85.5 33.5t-38.5 107.5v259h-127v-384h-84v384h-94v78h493v-78h-104v-251q0 -43 15 -57t38 -14q12 0 35 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 950,
    d: "M946 700l-270 -720l-201 551l-202 -551l-269 720h94l177 -485l172 485h61l170 -485l179 485h89zM357 887l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 742,
    d: "M262 670l52 52l149 -149l-50 -47zM8 462h91l124 -299l122 299h57l123 -299l123 299h86l-211 -482l-152 347l-152 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 950,
    d: "M946 700l-270 -720l-201 551l-202 -551l-269 720h94l177 -485l172 485h61l170 -485l179 485h89zM546 939l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 742,
    d: "M8 462h91l124 -299l122 299h57l123 -299l123 299h86l-211 -482l-152 347l-152 -347zM434 722l52 -52l-151 -144l-50 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    d: "M248 0v275l-236 425h94l188 -344l185 344h89l-236 -425v-275h-84zM149 887l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 500,
    d: "M27 -209l36 69q29 -24 55 -24t41.5 17t30.5 54l36 91l-216 464h95l162 -365l138 365h91q-232 -584 -243 -611q-19 -47 -53.5 -70t-74.5 -23q-25 0 -49.5 8t-36.5 16zM118 669l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 500,
    d: "M0 204v80h500v-80h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1000,
    d: "M0 204v80h1000v-80h-1000z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 150,
    d: "M40 462v238h70v-238h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 150,
    d: "M40 462v238h70v-238h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 150,
    d: "M40 -140v238h70v-238h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 332,
    d: "M60 462v238h72v-238h-72zM200 462v238h72v-238h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 332,
    d: "M60 462v238h72v-238h-72zM200 462v238h72v-238h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 332,
    d: "M60 -140v238h72v-238h-72zM200 -140v238h72v-238h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 520,
    d: "M80 447v74h140v179h78v-179h142v-74h-142v-527h-78v527h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 520,
    d: "M80 447v74h140v179h78v-179h142v-74h-142v-274h142v-74h-142v-179h-78v179h-140v74h140v274h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 500,
    d: "M129 350q0 50 35.5 85.5t85.5 35.5t85.5 -35.5t35.5 -85.5t-35.5 -85.5t-85.5 -35.5t-85.5 35.5t-35.5 85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1000,
    d: "M113 45q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM443 45q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM773 45q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1072,
    d: "M189 712q65 0 111 -45t46 -110t-46 -110t-111 -45t-111 45t-46 110t46 110t111 45zM189 456q42 0 70.5 29.5t28.5 71.5t-28.5 71.5t-70.5 29.5t-70.5 -29.5t-28.5 -71.5t28.5 -71.5t70.5 -29.5zM95 11l461 709l43 -29l-459 -711zM523 298q65 0 111 -45t46 -110t-46 -110 t-111 -45t-111 45t-46 110t46 110t111 45zM523 42q42 0 70.5 29.5t28.5 71.5t-28.5 71.5t-70.5 29.5t-70.5 -29.5t-28.5 -71.5t28.5 -71.5t70.5 -29.5zM883 298q65 0 111 -45t46 -110t-46 -110t-111 -45t-111 45t-46 110t46 110t111 45zM883 42q42 0 70.5 29.5t28.5 71.5 t-28.5 71.5t-70.5 29.5t-70.5 -29.5t-28.5 -71.5t28.5 -71.5t70.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 305,
    d: "M191 14l-177 231l177 231l59 -44l-146 -187l146 -187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 305,
    d: "M291 245l-177 -231l-59 44l146 187l-146 187l59 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 130,
    d: "M-194 0l475 730l43 -30l-473 -731z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 373,
    d: "M186 806q72 0 111.5 -63t39.5 -146t-39.5 -146t-111.5 -63t-111 62.5t-39 146.5t39 146.5t111 62.5zM186 440q49 0 72.5 48t23.5 109t-23.5 109t-72.5 48t-72.5 -48t-23.5 -109t23.5 -109t72.5 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 347,
    d: "M4 487l217 313h50v-259h54v-54h-54v-93h-56v93h-211zM102 541h113v164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 369,
    d: "M325 527q0 -65 -43.5 -102t-101.5 -37q-52 0 -85.5 27.5t-46.5 63.5l50 24q9 -25 30 -44t52 -19q36 0 62.5 23.5t26.5 63.5q0 43 -25 66t-64 23q-28 0 -56 -11t-42 -23l-15 -11v229h248v-52h-192v-95q29 15 67 15q54 0 94.5 -36.5t40.5 -104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 346,
    d: "M232 793l-85 -132q11 4 27 4q65 0 103.5 -40.5t38.5 -96.5q0 -57 -38.5 -98.5t-102.5 -41.5t-102.5 42t-38.5 98q0 37 28 86l127 209zM175 613q-38 0 -61.5 -25t-23.5 -60t23.5 -61.5t61.5 -26.5t61.5 26t23.5 62q0 35 -23.5 60t-61.5 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 318,
    d: "M22 748v52h294l-216 -416l-48 27l175 337h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 342,
    d: "M171 806q55 0 87.5 -34.5t32.5 -78.5q0 -59 -44 -82q57 -27 57 -98q0 -53 -37.5 -89t-95.5 -36t-95.5 36t-37.5 89q0 71 57 98q-44 23 -44 82q0 44 32.5 78.5t87.5 34.5zM171 440q34 0 56 21t22 52t-22 52t-56 21t-56 -21t-22 -52t22 -52t56 -21zM171 632q28 0 47 18 t19 43t-19 43t-47 18t-47 -18t-19 -43t19 -43t47 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 346,
    d: "M120 411l79 122q-11 -4 -27 -4q-65 0 -103.5 40.5t-38.5 96.5q0 57 38.5 98.5t102.5 41.5t102.5 -42t38.5 -98q0 -37 -28 -86l-121 -199zM171 581q38 0 61.5 25t23.5 60t-23.5 61.5t-61.5 26.5t-61.5 -26t-23.5 -62q0 -35 23.5 -60t61.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 373,
    d: "M186 319q72 0 111.5 -63t39.5 -146t-39.5 -146t-111.5 -63t-111 62.5t-39 146.5t39 146.5t111 62.5zM186 -47q49 0 72.5 47.5t23.5 109.5t-23.5 109.5t-72.5 47.5t-72.5 -47.5t-23.5 -109.5t23.5 -109.5t72.5 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 288,
    d: "M12 190l148 123h48v-406h-56v330l-107 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 350,
    d: "M257 72l-100 -111h152v-54h-279l165 181q17 19 26 29.5t18 29.5t9 38q0 34 -20.5 58t-59.5 24q-62 0 -88 -71l-51 21q14 43 51 72.5t88 29.5q60 0 98 -36.5t38 -97.5q0 -58 -47 -113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 352,
    d: "M251 205q0 27 -19.5 44.5t-51.5 17.5q-27 0 -47.5 -14t-27.5 -28l-7 -14l-46 23q1 3 4 9t13.5 20.5t23.5 26t36.5 20.5t50.5 9q55 0 91 -32.5t36 -81.5q0 -18 -5.5 -34t-13.5 -25.5t-16.5 -16t-13.5 -9.5l-6 -3q2 -1 6 -2.5t14 -8.5t17.5 -17t14 -28.5t6.5 -42.5 q0 -53 -40.5 -85t-98.5 -32q-30 0 -55 10t-39 24.5t-24 28.5t-13 24l-4 10l47 23l2.5 -7.5t8.5 -16t16 -20.5t25 -16.5t36 -7.5q35 0 59 17.5t24 47.5q0 71 -78 71h-24v52h17q36 0 59 15.5t23 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 347,
    d: "M2 0l217 313h50v-259h54v-54h-54v-93h-56v93h-211zM100 54h113v164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 369,
    d: "M325 40q0 -65 -43.5 -102t-101.5 -37q-52 0 -85.5 27.5t-46.5 63.5l50 24q9 -25 30 -44t52 -19q36 0 62.5 23.5t26.5 63.5q0 43 -25 66t-64 23q-28 0 -56 -11.5t-42 -22.5l-15 -11v229h248v-52h-192v-95q29 15 67 15q54 0 94.5 -36.5t40.5 -104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 346,
    d: "M232 306l-85 -132q11 4 27 4q65 0 103.5 -40.5t38.5 -96.5q0 -57 -38.5 -98.5t-102.5 -41.5t-102.5 42t-38.5 98q0 37 28 86l127 209zM175 126q-38 0 -61.5 -25t-23.5 -60t23.5 -61.5t61.5 -26.5t61.5 26t23.5 62q0 35 -23.5 60t-61.5 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 318,
    d: "M22 261v52h294l-216 -416l-48 27l175 337h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 342,
    d: "M171 319q55 0 87.5 -34.5t32.5 -78.5q0 -59 -44 -82q57 -27 57 -98q0 -53 -37.5 -89t-95.5 -36t-95.5 36t-37.5 89q0 71 57 98q-44 23 -44 82q0 44 32.5 78.5t87.5 34.5zM171 -47q34 0 56 21t22 52t-22 52t-56 21t-56 -21t-22 -52t22 -52t56 -21zM171 145q28 0 47 18 t19 43t-19 43t-47 18t-47 -18t-19 -43t19 -43t47 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 346,
    d: "M120 -76l79 122q-11 -4 -27 -4q-65 0 -103.5 40.5t-38.5 96.5q0 57 38.5 98.5t102.5 41.5t102.5 -42t38.5 -98q0 -37 -28 -86l-121 -199zM171 94q38 0 61.5 25t23.5 60t-23.5 61.5t-61.5 26.5t-61.5 -26t-23.5 -62q0 -35 23.5 -60t61.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    d: "M555 687l-29 -74q-42 19 -97 19q-85 0 -144.5 -51t-78.5 -132h232v-64h-244q-3 -36 0 -70h244v-64h-236q14 -85 79 -134t148 -49q56 0 103 21l24 -77q-57 -24 -137 -24q-124 0 -207 72.5t-99 190.5h-80v64h73q-3 34 0 70h-73v64h82q27 117 109.5 190t204.5 73 q64 0 126 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numero",
    unicode: "\u2116",
    horizAdvX: 1100,
    d: "M719 242v74h314v-74h-314zM876 712q80 0 126 -54t46 -117t-46 -117t-126 -54t-126 54t-46 117t46 117t126 54zM876 441q41 0 69.5 28t28.5 72q0 43 -28.5 71.5t-69.5 28.5t-69.5 -28.5t-28.5 -71.5q0 -44 28.5 -72t69.5 -28zM82 700h87l375 -560v560h84v-700h-87 l-375 560v-560h-84v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 767,
    d: "M120 330v317h-100v53h257v-53h-102v-317h-55zM345 700h55l126 -207l126 207h55v-370h-55v267l-126 -209l-126 209v-267h-55v370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 830,
    d: "M46 577l148 123h48v-406h-56v330l-107 -88zM162 0l475 730l43 -30l-473 -731zM726 298q0 27 -19.5 44.5t-51.5 17.5q-27 0 -47.5 -14t-27.5 -28l-7 -14l-46 23q1 3 4 9t13.5 20.5t23.5 26t36.5 20.5t50.5 9q55 0 91 -32.5t36 -81.5q0 -29 -14 -51t-28 -29l-13 -8 q2 -1 6 -2.5t14 -8.5t17.5 -17t14 -28.5t6.5 -42.5q0 -53 -40.5 -85t-98.5 -32q-30 0 -55 10t-39 24.5t-24 28.5t-14 24l-3 10l47 23l2.5 -7.5t8.5 -16t16 -20.5t25 -16.5t36 -7.5q35 0 59 17.5t24 47.5q0 71 -78 71h-24v52h17q36 0 59 15.5t23 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 830,
    d: "M252 459l-100 -111h152v-54h-279l165 181q17 19 26 29.5t18 29.5t9 38q0 34 -20.5 58t-59.5 24q-62 0 -88 -71l-51 21q14 43 51 72.5t88 29.5q60 0 98 -36.5t38 -97.5q0 -58 -47 -113zM736 298q0 27 -19.5 44.5t-51.5 17.5q-27 0 -47.5 -14t-27.5 -28l-7 -14l-46 23 q1 3 4 9t13.5 20.5t23.5 26t36.5 20.5t50.5 9q55 0 91 -32.5t36 -81.5q0 -29 -14 -51t-28 -29l-13 -8q2 -1 6 -2.5t14 -8.5t17.5 -17t14 -28.5t6.5 -42.5q0 -53 -40.5 -85t-98.5 -32q-30 0 -55 10t-39 24.5t-24 28.5t-14 24l-3 10l47 23l2.5 -7.5t8.5 -16t16 -20.5t25 -16.5 t36 -7.5q35 0 59 17.5t24 47.5q0 71 -78 71h-24v52h17q36 0 59 15.5t23 48.5zM176 0l475 730l43 -30l-473 -731z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 830,
    d: "M46 577l148 123h48v-406h-56v330l-107 -88zM162 0l475 730l43 -30l-473 -731zM649 412q55 0 87.5 -34.5t32.5 -78.5q0 -59 -44 -82q57 -27 57 -98q0 -53 -37.5 -89t-95.5 -36t-95.5 36t-37.5 89q0 71 57 98q-44 23 -44 82q0 44 32.5 78.5t87.5 34.5zM649 46q34 0 56 21 t22 52t-22 52t-56 21t-56 -21t-22 -52t22 -52t56 -21zM649 238q28 0 47 18t19 43t-19 43t-47 18t-47 -18t-19 -43t19 -43t47 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 830,
    d: "M649 412q55 0 87.5 -34.5t32.5 -78.5q0 -59 -44 -82q57 -27 57 -98q0 -53 -37.5 -89t-95.5 -36t-95.5 36t-37.5 89q0 71 57 98q-44 23 -44 82q0 44 32.5 78.5t87.5 34.5zM649 46q34 0 56 21t22 52t-22 52t-56 21t-56 -21t-22 -52t22 -52t56 -21zM649 238q28 0 47 18 t19 43t-19 43t-47 18t-47 -18t-19 -43t19 -43t47 -18zM162 0l475 730l43 -30l-473 -731zM259 592q0 27 -19.5 44.5t-51.5 17.5q-27 0 -47.5 -14t-27.5 -28l-7 -14l-46 23q1 3 4 9t13.5 20.5t23.5 26t36.5 20.5t50.5 9q55 0 91 -32.5t36 -81.5q0 -18 -5.5 -34t-13.5 -25.5 t-16.5 -16t-13.5 -9.5l-6 -3q2 -1 6 -2.5t14 -8.5t17.5 -17t14 -28.5t6.5 -42.5q0 -53 -40.5 -85t-98.5 -32q-30 0 -55 10t-39 24t-24 28.5t-13 24.5l-4 10l47 23l2.5 -7.5t8.5 -16t16 -20.5t25 -16.5t36 -7.5q35 0 59 17.5t24 47.5q0 71 -78 71h-24v52h17q36 0 59 15.5 t23 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 830,
    d: "M321 427q0 -65 -43.5 -102t-101.5 -37q-52 0 -85.5 27.5t-46.5 63.5l50 24q9 -25 30 -44t52 -19q36 0 62.5 23.5t26.5 63.5q0 43 -25 66t-64 23q-28 0 -56 -11t-42 -23l-15 -11v229h248v-52h-192v-95q29 15 67 15q54 0 94.5 -36.5t40.5 -104.5zM164 0l475 730l43 -30 l-473 -731zM649 412q55 0 87.5 -34.5t32.5 -78.5q0 -59 -44 -82q57 -27 57 -98q0 -53 -37.5 -89t-95.5 -36t-95.5 36t-37.5 89q0 71 57 98q-44 23 -44 82q0 44 32.5 78.5t87.5 34.5zM649 46q34 0 56 21t22 52t-22 52t-56 21t-56 -21t-22 -52t22 -52t56 -21zM649 238 q28 0 47 18t19 43t-19 43t-47 18t-47 -18t-19 -43t19 -43t47 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 830,
    d: "M70 648v52h294l-216 -416l-48 27l175 337h-205zM133 -1l475 730l43 -30l-473 -731zM653 411q55 0 87.5 -34.5t32.5 -78.5q0 -59 -44 -82q57 -27 57 -98q0 -53 -37.5 -89t-95.5 -36t-95.5 36t-37.5 89q0 71 57 98q-44 23 -44 82q0 44 32.5 78.5t87.5 34.5zM653 45 q34 0 56 21t22 52t-22 52t-56 21t-56 -21t-22 -52t22 -52t56 -21zM653 237q28 0 47 18t19 43t-19 43t-47 18t-47 -18t-19 -43t19 -43t47 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowleft",
    unicode: "\u2190",
    horizAdvX: 760,
    d: "M736 284v-74h-590l159 -173l-54 -53l-229 263l229 263l54 -53l-159 -173h590z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowup",
    unicode: "\u2191",
    horizAdvX: 600,
    d: "M337 0h-74v590l-173 -159l-53 54l263 229l263 -229l-53 -54l-173 159v-590z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowright",
    unicode: "\u2192",
    horizAdvX: 760,
    d: "M24 210v74h590l-159 173l54 53l229 -263l-229 -263l-54 53l159 173h-590z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowdown",
    unicode: "\u2193",
    horizAdvX: 600,
    d: "M263 700h74v-590l173 159l53 -54l-263 -229l-263 229l53 54l173 -159v590z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni21B3",
    unicode: "\u21B3",
    horizAdvX: 796,
    d: "M60 210v490h74v-416h516l-159 173l54 53l229 -263l-229 -263l-54 53l159 173h-590z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "carriagereturn",
    unicode: "\u21B5",
    horizAdvX: 796,
    d: "M736 700v-490h-590l159 -173l-54 -53l-229 263l229 263l54 -53l-159 -173h516v416h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 548,
    d: "M506 277q0 -134 -66.5 -211.5t-171.5 -77.5q-102 0 -170 70t-68 173t68 173t170 70q37 0 74.5 -14.5t63.5 -37.5q-17 48 -53.5 88t-77 62.5t-78 38.5t-61.5 22l-25 6l20 73q8 -1 21.5 -4t52.5 -15.5t74.5 -30.5t78.5 -52.5t74 -77.5t52.5 -108.5t21.5 -142.5v-4zM268 66 q68 0 111 47.5t43 117.5t-43 117.5t-111 47.5t-111 -47.5t-43 -117.5t43 -117.5t111 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 707,
    d: "M617 700v-930h-84v850h-359v-850h-84v930h527z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 738,
    d: "M24 -230l345 466l-343 464h664v-80h-504l285 -384l-287 -386h506v-80h-666z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 520,
    d: "M45 202v78h430v-78h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 625,
    d: "M322 179l248 781h79l-313 -972l-209 400h-87v74h137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 838,
    d: "M38 247q0 73 49 122q55 54 126 54q74 0 132 -58l74 -74l74 74q58 58 132 58q71 0 126 -54q49 -49 49 -122t-49 -122q-55 -54 -126 -54q-74 0 -132 58l-74 74l-74 -74q-58 -58 -132 -58q-71 0 -126 54q-49 49 -49 122zM532 170q42 -39 91 -39t83 32.5t34 83.5t-34 83.5 t-83 32.5t-91 -39l-78 -77q57 -59 78 -77zM215 131q49 0 91 39l78 77q-57 59 -78 77q-42 39 -91 39t-83 -32.5t-34 -83.5t34 -83.5t83 -32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 418,
    d: "M251 616v-712q0 -69 -43.5 -108t-98.5 -39q-48 0 -97 27l31 69q28 -18 54 -18q33 0 51.5 20t18.5 54v712q0 69 43.5 108t98.5 39q48 0 97 -27l-31 -69q-28 18 -54 18q-33 0 -51.5 -20t-18.5 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 520,
    d: "M111 270l-55 43q1 3 4 8.5t13.5 19.5t23.5 24.5t35.5 19t47.5 8.5q32 0 76 -23.5t63 -23.5q17 0 30.5 5.5t21 13t12 15.5t5.5 14l2 5l55 -43q-1 -3 -4 -8.5t-13 -19.5t-22.5 -24.5t-35 -19.5t-47.5 -9q-32 0 -78 23.5t-65 23.5q-26 0 -43 -13t-21 -26zM131 120l-55 43 q1 3 4 8.5t13.5 19.5t23.5 24.5t35.5 19t47.5 8.5q32 0 76 -23.5t63 -23.5q17 0 30.5 5.5t21 13t12 15.5t5.5 14l2 5l55 -43q-1 -3 -4 -8.5t-13 -19.5t-22.5 -24.5t-35 -19.5t-47.5 -9q-32 0 -78 23.5t-65 23.5q-26 0 -43 -13t-21 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 520,
    d: "M55 306v74h238l147 277l45 -26l-133 -251h113v-74h-152l-44 -84h196v-74h-235l-140 -265l-47 27l126 238h-114v74h154l44 84h-198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 520,
    d: "M18 336v77l462 188v-78l-363 -149l363 -148v-78zM18 0v76h462v-76h-462z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 520,
    d: "M502 413v-77l-462 -188v78l363 148l-363 149v78zM502 76v-76h-462v76h462z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 460,
    d: "M230 114l143 242l-143 233l-143 -233zM8 356l222 356l222 -356l-222 -370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "BALLOTBOX",
    unicode: "\u2610",
    horizAdvX: 844,
    d: "M82 0v700h680v-700h-680zM157 629v-558h530v558h-530z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "BALLOTBOXWITHCHECK",
    unicode: "\u2611",
    horizAdvX: 844,
    d: "M82 0v700h680v-700h-680zM157 629v-558h530v558h-530zM621 562l-181 -428h-81l-133 216h87l83 -146l145 358h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "BALLOTBOXWITHX",
    unicode: "\u2612",
    horizAdvX: 844,
    d: "M82 0v700h680v-700h-680zM248 589l174 -190l173 189l49 -48l-177 -190l175 -191l-49 -48l-171 190l-173 -190l-49 49l176 190l-176 190zM157 629v-558h530v558h-530z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "heart",
    unicode: "\u2665",
    horizAdvX: 654,
    d: "M327 127l-240 239q-42 42 -42 101t42 100q41 41 100 41q58 0 99 -41q36 -36 41 -86q5 51 40 86q41 41 100 41q57 0 100 -41q42 -41 42 -100q0 -61 -42 -101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2709",
    unicode: "\u2709",
    horizAdvX: 844,
    d: "M20 0v700h804v-700h-804zM422 210l-327 352v-491h654v491zM131 629l291 -314l292 314h-583z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni270E",
    unicode: "\u270E",
    horizAdvX: 844,
    d: "M819 434l-383 -382l-371 -52l52 371l382 383zM437 158l275 275l-214 214l-275 -275zM259 98l125 13l-208 208l-13 -124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2717",
    unicode: "\u2717",
    horizAdvX: 844,
    d: "M761 655l-283 -306l283 -305l-60 -56l-279 301l-279 -301l-60 56l283 305l-283 306l60 56l279 -301l279 301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni27F5",
    unicode: "\u27F5",
    horizAdvX: 1000,
    d: "M972 284v-74h-826l159 -173l-54 -53l-229 263l229 263l54 -53l-159 -173h826z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni27F6",
    unicode: "\u27F6",
    horizAdvX: 1000,
    d: "M28 210v74h826l-159 173l54 53l229 -263l-229 -263l-54 53l159 173h-826z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    unicode: "\uF655",
    horizAdvX: 373,
    d: "M186 412q72 0 111.5 -63t39.5 -146t-39.5 -146t-111.5 -63t-111 62.5t-39 146.5t39 146.5t111 62.5zM186 46q49 0 72.5 48t23.5 109t-23.5 109t-72.5 48t-72.5 -48t-23.5 -109t23.5 -109t72.5 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    unicode: "\uF656",
    horizAdvX: 288,
    d: "M12 283l148 123h48v-406h-56v330l-107 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    unicode: "\uF657",
    horizAdvX: 350,
    d: "M256 165l-100 -111h152v-54h-279l165 181q17 19 26 29.5t18 29.5t9 38q0 34 -20.5 58t-59.5 24q-62 0 -88 -71l-51 21q14 43 51 72.5t88 29.5q60 0 98 -36.5t38 -97.5q0 -58 -47 -113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    unicode: "\uF658",
    horizAdvX: 352,
    d: "M251 298q0 27 -19.5 44.5t-51.5 17.5q-27 0 -47.5 -14t-27.5 -28l-7 -14l-46 23q1 3 4 9t13.5 20.5t23.5 26t36.5 20.5t50.5 9q55 0 91 -32.5t36 -81.5q0 -18 -5.5 -34t-13.5 -25.5t-16.5 -16t-13.5 -9.5l-6 -3q2 -1 6 -2.5t14 -8.5t17.5 -17t14 -28.5t6.5 -42.5 q0 -53 -40.5 -85t-98.5 -32q-30 0 -55 10t-39 24.5t-24 28.5t-13 24l-4 10l47 23l2.5 -7.5t8.5 -16t16 -20.5t25 -16.5t36 -7.5q35 0 59 17.5t24 47.5q0 71 -78 71h-24v52h17q36 0 59 15.5t23 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    unicode: "\uF659",
    horizAdvX: 347,
    d: "M4 93l217 313h50v-259h54v-54h-54v-93h-56v93h-211zM102 147h113v164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    unicode: "\uF65A",
    horizAdvX: 369,
    d: "M325 133q0 -65 -43.5 -102t-101.5 -37q-52 0 -85.5 27.5t-46.5 63.5l50 24q9 -25 30 -44t52 -19q36 0 62.5 23.5t26.5 63.5q0 43 -25 66t-64 23q-28 0 -56 -11t-42 -23l-15 -11v229h248v-52h-192v-95q29 15 67 15q54 0 94.5 -36.5t40.5 -104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    unicode: "\uF65B",
    horizAdvX: 346,
    d: "M232 399l-85 -132q11 4 27 4q65 0 103.5 -40.5t38.5 -96.5q0 -57 -38.5 -98.5t-102.5 -41.5t-102.5 42t-38.5 98q0 37 28 86l127 209zM175 219q-38 0 -61.5 -25t-23.5 -60t23.5 -61.5t61.5 -26.5t61.5 26t23.5 62q0 35 -23.5 60t-61.5 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    unicode: "\uF65C",
    horizAdvX: 318,
    d: "M22 354v52h294l-216 -416l-48 27l175 337h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    unicode: "\uF65D",
    horizAdvX: 342,
    d: "M171 412q55 0 87.5 -34.5t32.5 -78.5q0 -59 -44 -82q57 -27 57 -98q0 -53 -37.5 -89t-95.5 -36t-95.5 36t-37.5 89q0 71 57 98q-44 23 -44 82q0 44 32.5 78.5t87.5 34.5zM171 46q34 0 56 21t22 52t-22 52t-56 21t-56 -21t-22 -52t22 -52t56 -21zM171 238q28 0 47 18 t19 43t-19 43t-47 18t-47 -18t-19 -43t19 -43t47 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    unicode: "\uF65E",
    horizAdvX: 346,
    d: "M120 17l79 122q-11 -4 -27 -4q-65 0 -103.5 40.5t-38.5 96.5q0 57 38.5 98.5t102.5 41.5t102.5 -42t38.5 -98q0 -37 -28 -86l-121 -199zM171 187q38 0 61.5 25t23.5 60t-23.5 61.5t-61.5 26.5t-61.5 -26t-23.5 -62q0 -35 23.5 -60t61.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    unicode: "\uF661",
    horizAdvX: 373,
    d: "M186 706q72 0 111.5 -63t39.5 -146t-39.5 -146t-111.5 -63t-111 62.5t-39 146.5t39 146.5t111 62.5zM186 340q49 0 72.5 48t23.5 109t-23.5 109t-72.5 48t-72.5 -48t-23.5 -109t23.5 -109t72.5 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    unicode: "\uF662",
    horizAdvX: 288,
    d: "M12 577l148 123h48v-406h-56v330l-107 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    unicode: "\uF663",
    horizAdvX: 350,
    d: "M256 459l-100 -111h152v-54h-279l165 181q17 19 26 29.5t18 29.5t9 38q0 34 -20.5 58t-59.5 24q-62 0 -88 -71l-51 21q14 43 51 72.5t88 29.5q60 0 98 -36.5t38 -97.5q0 -58 -47 -113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    unicode: "\uF664",
    horizAdvX: 352,
    d: "M251 592q0 27 -19.5 44.5t-51.5 17.5q-27 0 -47.5 -14t-27.5 -28l-7 -14l-46 23q1 3 4 9t13.5 20.5t23.5 26t36.5 20.5t50.5 9q55 0 91 -32.5t36 -81.5q0 -18 -5.5 -34t-13.5 -25.5t-16.5 -16t-13.5 -9.5l-6 -3q2 -1 6 -2.5t14 -8.5t17.5 -17t14 -28.5t6.5 -42.5 q0 -53 -40.5 -85t-98.5 -32q-30 0 -55 10t-39 24t-24 28.5t-13 24.5l-4 10l47 23l2.5 -7.5t8.5 -16t16 -20.5t25 -16.5t36 -7.5q35 0 59 17.5t24 47.5q0 71 -78 71h-24v52h17q36 0 59 15.5t23 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    unicode: "\uF665",
    horizAdvX: 347,
    d: "M2 387l217 313h50v-259h54v-54h-54v-93h-56v93h-211zM100 441h113v164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    unicode: "\uF666",
    horizAdvX: 369,
    d: "M325 427q0 -65 -43.5 -102t-101.5 -37q-52 0 -85.5 27.5t-46.5 63.5l50 24q9 -25 30 -44t52 -19q36 0 62.5 23.5t26.5 63.5q0 43 -25 66t-64 23q-28 0 -56 -11t-42 -23l-15 -11v229h248v-52h-192v-95q29 15 67 15q54 0 94.5 -36.5t40.5 -104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    unicode: "\uF667",
    horizAdvX: 346,
    d: "M232 693l-85 -132q11 4 27 4q65 0 103.5 -40.5t38.5 -96.5q0 -57 -38.5 -98.5t-102.5 -41.5t-102.5 42t-38.5 98q0 37 28 86l127 209zM175 513q-38 0 -61.5 -25t-23.5 -60t23.5 -61.5t61.5 -26.5t61.5 26t23.5 62q0 35 -23.5 60t-61.5 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    unicode: "\uF668",
    horizAdvX: 318,
    d: "M22 648v52h294l-216 -416l-48 27l175 337h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    unicode: "\uF669",
    horizAdvX: 342,
    d: "M171 706q55 0 87.5 -34.5t32.5 -78.5q0 -59 -44 -82q57 -27 57 -98q0 -53 -37.5 -89t-95.5 -36t-95.5 36t-37.5 89q0 71 57 98q-44 23 -44 82q0 44 32.5 78.5t87.5 34.5zM171 340q34 0 56 21t22 52t-22 52t-56 21t-56 -21t-22 -52t22 -52t56 -21zM171 532q28 0 47 18 t19 43t-19 43t-47 18t-47 -18t-19 -43t19 -43t47 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    unicode: "\uF66A",
    horizAdvX: 346,
    d: "M120 311l79 122q-11 -4 -27 -4q-65 0 -103.5 40.5t-38.5 96.5q0 57 38.5 98.5t102.5 41.5t102.5 -42t38.5 -98q0 -37 -28 -86l-121 -199zM171 481q38 0 61.5 25t23.5 60t-23.5 61.5t-61.5 26.5t-61.5 -26t-23.5 -62q0 -35 23.5 -60t61.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at.alt",
    horizAdvX: 799,
    d: "M585 72l17 -37q-88 -47 -192 -47q-150 0 -256 106t-106 256t106 256t256 106q148 0 244.5 -101t96.5 -246q0 -66 -15 -112t-39.5 -67t-46.5 -29t-45 -8h-2q-84 0 -102 71l-5 -7.5t-14 -17t-24.5 -22t-35.5 -17t-46 -7.5q-51 0 -91.5 36t-40.5 93q0 55 41.5 90.5 t104.5 35.5q29 0 55 -12t38 -24l12 -12v30q0 54 -27.5 75.5t-64.5 21.5q-29 0 -55.5 -9.5t-39.5 -19.5l-12 -10l-29 53q7 5 19 13t47.5 21.5t70.5 13.5q73 0 114.5 -39t41.5 -106v-166q0 -43 46 -43h2q100 0 100 174q0 129 -83 217t-215 88q-135 0 -227 -93t-92 -227 q0 -133 92.5 -226.5t226.5 -93.5q96 0 175 42zM390 209q22 0 41 6.5t30.5 16t19.5 19t11 15.5l3 7v30q-4 5 -11 12.5t-33 19.5t-55 12q-36 0 -60 -20t-24 -49q0 -34 22.5 -51.5t55.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 553,
    d: "M405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38 18.5t-48.5 8.5q-69 0 -111.5 -47.5t-42.5 -117.5t42.5 -117.5t111.5 -47.5q25 0 48.5 8t38.5 19.5t26.5 23t16.5 19.5zM412 462h77v-462h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30.5 -24t-44.5 -19t-60 -8.5 q-92 0 -157 70.5t-65 172.5t65 172.5t157 70.5q50 0 89.5 -20t54.5 -40l14 -19v67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "euro.alt",
    horizAdvX: 739,
    d: "M18 385v64h104q28 117 116.5 190t212.5 73q157 0 260 -116l-63 -52q-76 90 -197 90q-85 0 -147.5 -51.5t-88.5 -133.5h332v-64h-345q-2 -22 -2 -35t2 -35h303v-64h-290q26 -82 88.5 -132.5t147.5 -50.5q61 0 115.5 28t89.5 74l59 -57q-106 -125 -264 -125q-128 0 -214 72 t-115 191h-104v64h93q-1 11 -1 35q0 23 1 35h-93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet.alt",
    horizAdvX: 500,
    d: "M40 350q0 87 61.5 148.5t148.5 61.5t148.5 -61.5t61.5 -148.5t-61.5 -148.5t-148.5 -61.5t-148.5 61.5t-61.5 148.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph.alt",
    horizAdvX: 555,
    d: "M24 513q0 77 55 132t132 55h262v-700h-84v622h-94v-622h-84v326q-77 0 -132 55t-55 132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fj",
    horizAdvX: 539,
    d: "M255 -221l30 70q23 -13 35 -13q15 0 25 3.5t19 20.5t9 47v555h84v-563q0 -74 -38.5 -107.5t-85.5 -33.5q-42 0 -78 21zM372 586v14q0 35 -22 62.5t-65 27.5t-65 -27.5t-22 -62.5v-138h103v-76h-103v-386h-84v386h-94v76h94v134q0 73 47.5 122.5t123.5 49.5t123.5 -49.5 t47.5 -122.5v-10q0 -17 -12.5 -29.5t-29.5 -12.5t-29.5 12.5t-12.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ft",
    horizAdvX: 649,
    d: "M198 462h190v141h84v-141h144v-76h-144v-246q0 -35 17 -54.5t50 -19.5q12 0 25 5t20 9l8 5l31 -69q-51 -28 -96 -28q-55 0 -97 39t-42 108v251h-190v-386h-84v386h-94v76h94v159q0 69 43.5 108t98.5 39q48 0 97 -27l-31 -69q-28 18 -54 18q-33 0 -51.5 -20t-18.5 -54 v-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave.alt",
    horizAdvX: 553,
    d: "M405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38 18.5t-48.5 8.5q-69 0 -111.5 -47.5t-42.5 -117.5t42.5 -117.5t111.5 -47.5q25 0 48.5 8t38.5 19.5t26.5 23t16.5 19.5zM412 462h77v-462h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30.5 -24t-44.5 -19t-60 -8.5 q-92 0 -157 70.5t-65 172.5t65 172.5t157 70.5q50 0 89.5 -20t54.5 -40l14 -19v67zM156 669l52 52l149 -149l-50 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute.alt",
    horizAdvX: 553,
    d: "M361 721l52 -52l-151 -144l-50 47zM405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38 18.5t-48.5 8.5q-69 0 -111.5 -47.5t-42.5 -117.5t42.5 -117.5t111.5 -47.5q25 0 48.5 8t38.5 19.5t26.5 23t16.5 19.5zM412 462h77v-462h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30.5 -24 t-44.5 -19t-60 -8.5q-92 0 -157 70.5t-65 172.5t65 172.5t157 70.5q50 0 89.5 -20t54.5 -40l14 -19v67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex.alt",
    horizAdvX: 553,
    d: "M405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38 18.5t-48.5 8.5q-69 0 -111.5 -47.5t-42.5 -117.5t42.5 -117.5t111.5 -47.5q25 0 48.5 8t38.5 19.5t26.5 23t16.5 19.5zM412 462h77v-462h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30.5 -24t-44.5 -19t-60 -8.5 q-92 0 -157 70.5t-65 172.5t65 172.5t157 70.5q50 0 89.5 -20t54.5 -40l14 -19v67zM278 702l166 -121l-46 -54l-120 92l-120 -92l-46 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde.alt",
    horizAdvX: 553,
    d: "M405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38 18.5t-48.5 8.5q-69 0 -111.5 -47.5t-42.5 -117.5t42.5 -117.5t111.5 -47.5q25 0 48.5 8t38.5 19.5t26.5 23t16.5 19.5zM412 462h77v-462h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30.5 -24t-44.5 -19t-60 -8.5 q-92 0 -157 70.5t-65 172.5t65 172.5t157 70.5q50 0 89.5 -20t54.5 -40l14 -19v67zM167 553l-59 37q1 3 3.5 9t12 20.5t21.5 25.5t33 20t45 9q28 0 64 -22.5t48 -22.5q19 0 33 12.5t19 24.5l5 13l58 -37l-3 -9t-11 -20.5t-20.5 -25.5t-32.5 -20t-45 -9q-30 0 -66 22.5 t-48 22.5q-19 0 -33.5 -12.5t-18.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis.alt",
    horizAdvX: 553,
    d: "M405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38 18.5t-48.5 8.5q-69 0 -111.5 -47.5t-42.5 -117.5t42.5 -117.5t111.5 -47.5q25 0 48.5 8t38.5 19.5t26.5 23t16.5 19.5zM412 462h77v-462h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30.5 -24t-44.5 -19t-60 -8.5 q-92 0 -157 70.5t-65 172.5t65 172.5t157 70.5q50 0 89.5 -20t54.5 -40l14 -19v67zM130 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40zM311 610q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring.alt",
    horizAdvX: 553,
    d: "M405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38 18.5t-48.5 8.5q-69 0 -111.5 -47.5t-42.5 -117.5t42.5 -117.5t111.5 -47.5q25 0 48.5 8t38.5 19.5t26.5 23t16.5 19.5zM412 462h77v-462h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30.5 -24t-44.5 -19t-60 -8.5 q-92 0 -157 70.5t-65 172.5t65 172.5t157 70.5q50 0 89.5 -20t54.5 -40l14 -19v67zM221 644q0 -23 16 -39t39 -16t39 16t16 39t-16 39t-39 16t-39 -16t-16 -39zM168 644q0 45 31.5 76.5t76.5 31.5t76.5 -31.5t31.5 -76.5t-31.5 -76.5t-76.5 -31.5t-76.5 31.5t-31.5 76.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron.alt",
    horizAdvX: 553,
    d: "M405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38 18.5t-48.5 8.5q-69 0 -111.5 -47.5t-42.5 -117.5t42.5 -117.5t111.5 -47.5q25 0 48.5 8t38.5 19.5t26.5 23t16.5 19.5zM412 462h77v-462h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30.5 -24t-44.5 -19t-60 -8.5 q-92 0 -157 70.5t-65 172.5t65 172.5t157 70.5q50 0 89.5 -20t54.5 -40l14 -19v67zM134 572v69h302v-69h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve.alt",
    horizAdvX: 553,
    d: "M405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38 18.5t-48.5 8.5q-69 0 -111.5 -47.5t-42.5 -117.5t42.5 -117.5t111.5 -47.5q25 0 48.5 8t38.5 19.5t26.5 23t16.5 19.5zM412 462h77v-462h-77v67q-2 -3 -5.5 -8.5t-17.5 -19t-30.5 -24t-44.5 -19t-60 -8.5 q-92 0 -157 70.5t-65 172.5t65 172.5t157 70.5q50 0 89.5 -20t54.5 -40l14 -19v67zM115 700h75v-8.5t4 -20t11 -25t24 -19.5t40 -9q37 0 56.5 20.5t20.5 41.5l2 20h75q0 -6 -1 -16t-10 -36t-23.5 -45.5t-46 -35.5t-73.5 -16t-73.5 15.5t-46 37.5t-23.5 43.5t-10 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek.alt",
    horizAdvX: 553,
    d: "M412 462h77v-462h-1q-7 -2 -16 -5t-27.5 -12.5t-30.5 -25.5t-12 -36q0 -23 14.5 -36t36.5 -13q10 0 19 2t13 4l4 1v-69q-18 -7 -46 -7q-47 0 -77 29.5t-30 72.5q0 26 10 47t25 33t24.5 17.5t16.5 7.5v57q-2 -3 -5.5 -8.5t-17.5 -19t-30.5 -24t-44.5 -19t-60 -8.5 q-92 0 -157 70.5t-65 172.5t65 172.5t157 70.5q50 0 89.5 -20t54.5 -40l14 -19v67zM405 144v174q-2 3 -5.5 8.5t-16 19t-27 23.5t-38 18.5t-48.5 8.5q-69 0 -111.5 -47.5t-42.5 -117.5t42.5 -117.5t111.5 -47.5q25 0 48.5 8t38.5 19.5t26.5 23t16.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum_tnum",
    d: "M291 712q64 0 112.5 -32t76 -85t41 -115t13.5 -130t-13.5 -130t-41 -115t-76 -85t-112.5 -32t-112.5 32t-76.5 85t-42 115t-14 130t14 130t42 115t76.5 85t112.5 32zM291 64q44 0 76.5 27t49.5 72t25 91.5t8 95.5t-8 95.5t-25 90.5t-49.5 71t-76.5 27t-77 -27t-50.5 -71 t-25.5 -90.5t-8 -95.5t8 -95.5t25.5 -91t50.5 -72t77 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum_tnum",
    d: "M75 505l245 195h75v-700h-84v590l-186 -148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum_tnum",
    d: "M70 0l246 326l15 19q15 19 20.5 26.5t18 28t18.5 34.5t11.5 34.5t5.5 38.5q0 54 -33.5 90.5t-95.5 36.5q-49 0 -83.5 -27t-44.5 -53l-10 -27l-72 27q2 6 5.5 17t19.5 38t37.5 48t60.5 38t87 17q95 0 154 -58.5t59 -146.5q0 -19 -3 -38t-9 -35.5t-12 -30t-14.5 -27.5 t-13.5 -21l-12.5 -17.5t-8.5 -11.5l-186 -248h264v-78h-424z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum_tnum",
    d: "M395 515q0 48 -35.5 83.5t-89.5 35.5q-44 0 -77 -23t-43 -45l-11 -23l-72 32q2 6 6.5 15t21 32.5t37.5 41.5t58 33t80 15q87 0 148 -57t61 -140q0 -32 -9 -59.5t-21.5 -43.5t-25 -28t-21.5 -16l-9 -5q4 -1 11 -3.5t25 -15t31.5 -29.5t24.5 -49.5t11 -72.5q0 -93 -65 -149 t-163 -56q-50 0 -92 16.5t-65.5 40t-40 46.5t-22.5 39l-5 17l74 34q1 -5 4 -12.5t14.5 -27.5t27 -35t43.5 -27.5t62 -12.5q65 0 104.5 37t39.5 90q0 60 -37.5 93t-110.5 33h-33v77h21q62 0 102.5 30.5t40.5 88.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum_tnum",
    d: "M0 184l365 516h74v-438h87v-78h-87v-184h-82v184h-357zM140 262h217v310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum_tnum",
    d: "M525 223q0 -111 -70 -173t-168 -62q-48 0 -89 15.5t-65.5 37.5t-42 44.5t-24.5 38.5l-6 15l73 39l5 -12.5t16 -26.5t29 -34t44 -27t60 -12q65 0 109.5 41.5t44.5 115.5q0 76 -44 116.5t-112 40.5q-43 0 -90.5 -19.5t-73.5 -38.5l-26 -20v398h415v-78h-335v-192 q51 29 129 29q92 0 156.5 -61.5t64.5 -174.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum_tnum",
    d: "M392 680l-151 -240q21 10 50 10q105 0 167 -67.5t62 -161.5t-62 -163.5t-167 -69.5t-167 69.5t-62 161.5q0 61 34 124l228 381zM291 372q-64 0 -104.5 -44t-40.5 -107q0 -64 40 -109.5t105 -45.5t105 45.5t40 109.5q0 63 -40.5 107t-104.5 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum_tnum",
    d: "M82 622v78h466l-372 -718l-71 38l311 602h-334z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum_tnum",
    d: "M290 712q89 0 143 -57t54 -131q0 -43 -21.5 -83.5t-56.5 -61.5q48 -26 75.5 -73t27.5 -106q0 -88 -62 -150t-160 -62t-160 62t-62 150q0 59 27.5 106t75.5 73q-35 21 -56.5 61.5t-21.5 83.5q0 74 54 131t143 57zM290 66q61 0 99.5 40.5t38.5 93.5q0 57 -38 98t-100 41 t-100 -41t-38 -98q0 -53 38.5 -93.5t99.5 -40.5zM290 412q48 0 80.5 31.5t32.5 79.5t-32.5 79.5t-80.5 31.5t-80.5 -31.5t-32.5 -79.5t32.5 -79.5t80.5 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum_tnum",
    d: "M189 23l151 241q-15 -12 -51 -12q-105 0 -167 68t-62 160t62 162t167 70t167 -70t62 -162q0 -51 -28 -109l-233 -392zM289 330q64 0 104.5 43.5t40.5 106.5q0 64 -40 109t-105 45t-105 -45t-40 -109q0 -63 40.5 -106.5t104.5 -43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.onum_pnum",
    horizAdvX: 550,
    d: "M275 474q102 0 173.5 -70.5t71.5 -172.5t-71.5 -172.5t-173.5 -70.5t-173.5 70.5t-71.5 172.5t71.5 172.5t173.5 70.5zM275 66q69 0 115 48t46 117t-46 117t-115 48t-115 -48t-46 -117t46 -117t115 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.onum_pnum",
    horizAdvX: 365,
    d: "M18 309l192 153h75v-462h-84v357l-135 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.onum_pnum",
    horizAdvX: 466,
    d: "M349 193l-110 -115h166v-78h-353l192 198q3 3 15 15.5t16.5 17.5t13 16.5t12 19t7 19t3.5 22.5q0 37 -23 62.5t-63 25.5q-35 0 -61.5 -19.5t-35.5 -38.5l-9 -20l-71 29q2 5 5.5 13.5t18 30.5t32.5 39t50.5 30.5t70.5 13.5q72 0 121 -47.5t49 -118.5q0 -62 -46 -115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.onum_pnum",
    horizAdvX: 500,
    d: "M370 287q0 46 -32.5 77.5t-81.5 31.5q-27 0 -50 -9t-36.5 -22t-23.5 -26.5t-14 -22.5l-3 -9l-70 33q2 5 6 14.5t20 32.5t36.5 40.5t56.5 32t78 14.5q84 0 140 -55t56 -132q0 -29 -8 -54t-19.5 -40.5t-23.5 -27t-19.5 -16t-8.5 -4.5q4 -1 9.5 -4t20.5 -15t26.5 -28t21 -46 t9.5 -67q0 -85 -62 -140t-151 -55q-45 0 -83.5 16t-61 38.5t-38.5 45t-22 38.5l-6 16l72 32q1 -4 4 -11.5t14 -26t25.5 -33t40 -26t55.5 -11.5q58 0 93.5 33t35.5 84q0 57 -33 87t-95 30h-41v76h37q59 0 92.5 28.5t33.5 80.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.onum_pnum",
    horizAdvX: 532,
    d: "M0 0l351 462h76v-384h73v-78h-73v-198h-82v198h-345zM151 78h194v257z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.onum_pnum",
    horizAdvX: 559,
    d: "M507 15q0 -107 -66.5 -166t-162.5 -59q-47 0 -86.5 15.5t-62.5 38t-39.5 45t-23.5 37.5l-6 16l71 34q2 -4 5 -11.5t16 -26t28 -33t41.5 -26t56.5 -11.5q62 0 103.5 40.5t41.5 106.5q0 67 -40.5 107t-105.5 40q-45 0 -91.5 -19t-70.5 -38l-24 -19v376h389v-78h-309v-173 q54 29 118 29q94 0 156 -58.5t62 -166.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.onum_pnum",
    horizAdvX: 540,
    d: "M373 680l-151 -240q21 10 50 10q105 0 167 -67.5t62 -161.5t-62 -163.5t-167 -69.5t-167 69.5t-62 161.5q0 61 34 124l228 381zM272 372q-64 0 -104.5 -44t-40.5 -107q0 -64 40 -109.5t105 -45.5t105 45.5t40 109.5q0 63 -40.5 107t-104.5 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.onum_pnum",
    horizAdvX: 471,
    d: "M28 384v78h449l-348 -672l-71 38l287 556h-317z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.onum_pnum",
    horizAdvX: 548,
    d: "M274 712q89 0 143 -57.5t54 -131.5q0 -43 -21.5 -83.5t-56.5 -61.5q48 -26 75.5 -72.5t27.5 -105.5q0 -88 -62 -150t-160 -62t-160 62t-62 150q0 59 27.5 105.5t75.5 72.5q-35 21 -56.5 61.5t-21.5 83.5q0 74 54 131.5t143 57.5zM274 66q61 0 99.5 40.5t38.5 93.5 q0 57 -38 98t-100 41t-100 -41t-38 -98q0 -53 38.5 -93.5t99.5 -40.5zM274 412q48 0 80.5 31.5t32.5 79.5t-32.5 79.5t-80.5 31.5t-80.5 -31.5t-32.5 -79.5t32.5 -79.5t80.5 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.onum_pnum",
    horizAdvX: 522,
    d: "M190 -171l120 215q-24 -6 -50 -6q-98 0 -159 65.5t-61 152.5q0 86 61.5 152t158.5 66t158.5 -66t61.5 -152q0 -39 -22 -93l-198 -374zM260 116q62 0 100 41t38 99t-38 99t-100 41t-100 -41t-38 -99t38 -99t100 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.onum_tnum",
    d: "M290 474q102 0 173.5 -70.5t71.5 -172.5t-71.5 -172.5t-173.5 -70.5t-173.5 70.5t-71.5 172.5t71.5 172.5t173.5 70.5zM290 66q69 0 115 48t46 117t-46 117t-115 48t-115 -48t-46 -117t46 -117t115 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.onum_tnum",
    d: "M95 276l231 186h75v-462h-84v357l-174 -141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.onum_tnum",
    d: "M412 193l-110 -115h166v-78h-353l192 198q3 3 15 15.5t16.5 17.5t13 16.5t12 19t7 19t3.5 22.5q0 37 -23 62.5t-63 25.5q-35 0 -61.5 -19.5t-35.5 -38.5l-9 -20l-71 29q2 5 5.5 13.5t18 30.5t32.5 39t50.5 30.5t70.5 13.5q72 0 121 -47.5t49 -118.5q0 -62 -46 -115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.onum_tnum",
    d: "M390 287q0 46 -32.5 77.5t-81.5 31.5q-27 0 -50 -9t-36.5 -22t-23.5 -26.5t-14 -22.5l-3 -9l-70 33q2 5 6 14.5t20 32.5t36.5 40.5t56.5 32t78 14.5q84 0 140 -55t56 -132q0 -29 -8 -54t-19.5 -40.5t-23.5 -27t-19.5 -16t-8.5 -4.5q4 -1 9.5 -4t20.5 -15t26.5 -28t21 -46 t9.5 -67q0 -85 -62 -140t-151 -55q-45 0 -83.5 16t-61 38.5t-38.5 45t-22 38.5l-6 16l72 32q1 -4 4 -11.5t14 -26t25.5 -33t40 -26t55.5 -11.5q58 0 93.5 33t35.5 84q0 57 -33 87t-95 30h-41v76h37q59 0 92.5 28.5t33.5 80.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.onum_tnum",
    d: "M0 0l351 462h76v-384h73v-78h-73v-198h-82v198h-345zM151 78h194v257z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.onum_tnum",
    d: "M524 15q0 -107 -66.5 -166t-162.5 -59q-47 0 -86.5 15.5t-62.5 38t-39.5 45t-22.5 37.5l-7 16l71 34q2 -4 5 -11.5t16 -26t28 -33t41.5 -26t56.5 -11.5q62 0 103.5 40.5t41.5 106.5q0 67 -40.5 107t-105.5 40q-45 0 -91.5 -19t-70.5 -38l-24 -19v376h389v-78h-309v-173 q54 29 118 29q94 0 156 -58.5t62 -166.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.onum_tnum",
    d: "M393 680l-151 -240q21 10 50 10q105 0 167 -67.5t62 -161.5t-62 -163.5t-167 -69.5t-167 69.5t-62 161.5q0 61 34 124l228 381zM292 372q-64 0 -104.5 -44t-40.5 -107q0 -64 40 -109.5t105 -45.5t105 45.5t40 109.5q0 63 -40.5 107t-104.5 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.onum_tnum",
    d: "M92 384v78h449l-348 -672l-71 38l287 556h-317z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.onum_tnum",
    d: "M290 712q89 0 143 -57.5t54 -131.5q0 -43 -21.5 -83.5t-56.5 -61.5q48 -26 75.5 -72.5t27.5 -105.5q0 -88 -62 -150t-160 -62t-160 62t-62 150q0 59 27.5 105.5t75.5 72.5q-35 21 -56.5 61.5t-21.5 83.5q0 74 54 131.5t143 57.5zM290 66q61 0 99.5 40.5t38.5 93.5 q0 57 -38 98t-100 41t-100 -41t-38 -98q0 -53 38.5 -93.5t99.5 -40.5zM290 412q48 0 80.5 31.5t32.5 79.5t-32.5 79.5t-80.5 31.5t-80.5 -31.5t-32.5 -79.5t32.5 -79.5t80.5 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.onum_tnum",
    d: "M218 -171l120 215q-24 -6 -50 -6q-98 0 -159 65.5t-61 152.5q0 86 61.5 152t158.5 66t158.5 -66t61.5 -152q0 -39 -22 -93l-198 -374zM288 116q62 0 100 41t38 99t-38 99t-100 41t-100 -41t-38 -99t38 -99t100 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Circle",
    horizAdvX: 844,
    d: "M62 350q0 151 104.5 256.5t254.5 105.5q151 0 256 -105.5t105 -256.5q0 -150 -105.5 -256t-255.5 -106t-254.5 106t-104.5 256zM135 350q0 -119 83.5 -203.5t202.5 -84.5t202.5 84.5t83.5 203.5t-83.5 203.5t-202.5 84.5t-202.5 -84.5t-83.5 -203.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "CircleDotted",
    horizAdvX: 844,
    d: "M62 350q0 151 104.5 256.5t254.5 105.5q151 0 256 -105.5t105 -256.5q0 -150 -105.5 -256t-255.5 -106t-254.5 106t-104.5 256zM135 350q0 -119 83.5 -203.5t202.5 -84.5t202.5 84.5t83.5 203.5t-83.5 203.5t-202.5 84.5t-202.5 -84.5t-83.5 -203.5zM282 350 q0 57 41 98.5t98 41.5t98.5 -41.5t41.5 -98.5t-41.5 -98t-98.5 -41q-58 0 -98.5 40.5t-40.5 98.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Trash",
    horizAdvX: 844,
    d: "M666 0h-488l-133 700h754zM501 620h-158l9 -152h140zM551 620l-9 -152h124l27 152h-142zM293 620h-142l27 -152h124zM354 424l9 -150h117l9 150h-135zM185 424l27 -150h101l-9 150h-119zM539 424l-9 -150h102l26 150h-119zM366 230l9 -150h94l9 150h-112zM528 230 l-9 -150h79l26 150h-96zM219 230l27 -150h79l-9 150h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "EuropaType",
    horizAdvX: 776,
    d: "M619 194l24 -64q-32 -21 -92 -38q-8 13 -24 13q-12 0 -20.5 -8.5t-8.5 -20.5t8.5 -20.5t20.5 -8.5q11 0 19.5 8t9.5 19q43 12 94 38l24 -63q-12 -7 -33 -17t-82 -26.5t-118 -16.5q-21 30 -23 84q0 41 11 67q49 0 96.5 13.5t70.5 26.5zM211 408h363q-3 63 -52 109t-130 46 q-77 0 -126 -46t-55 -109zM391 712q153 0 245.5 -101.5t92.5 -264.5q0 -4 -3 -55h-514q9 -60 61.5 -102.5t133.5 -47.5q-11 -33 -11 -69q2 -50 21 -84h-6q-160 0 -262 105t-102 257t96 257t248 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period.tabular",
    d: "M233 45q0 23 17 40t40 17t40 -17t17 -40t-17 -40t-40 -17t-40 17t-17 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space.tabular"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "aogonek.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "abreve.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "amacron.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "aring.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "adieresis.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "atilde.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "acircumflex.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "aacute.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "agrave.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "a.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0161",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u015F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u015D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u015B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0153",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0151",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u014F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u014D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u011B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0119",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0117",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0115",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0113",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u010D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u010B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0109",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0107",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEA",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "s",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "o",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "e",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "c",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "q",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "g",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "d",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "aogonek.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "abreve.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "amacron.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "aring.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "adieresis.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "atilde.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "acircumflex.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "aacute.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "agrave.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "a.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0161",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u015F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u015D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u015B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0153",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0151",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u014F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u014D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u011B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0119",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0117",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0115",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0113",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u010D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u010B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0109",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0107",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEA",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "s",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "o",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "e",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "c",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "q",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "g",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "d",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1EF3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1E83",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1E81",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0177",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0175",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xFF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "w",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "v",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EF3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E83",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E82",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E81",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E80",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0177",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0175",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0174",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0164",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0162",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xFF",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "y",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "w",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "W",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "T",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "v",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ",",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "aogonek.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "abreve.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "amacron.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "aring.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "adieresis.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "atilde.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "acircumflex.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "aacute.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "agrave.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "a.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0151",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014D",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011B",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0117",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0115",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0113",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010D",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010B",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0109",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0105",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0103",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0101",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "q",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "g",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "d",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1EF2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0178",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0176",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Y",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201E",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xBB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ";",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ":",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "aogonek.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "abreve.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "amacron.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "aring.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "adieresis.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "atilde.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "acircumflex.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "aacute.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "agrave.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "a.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0177",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0173",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0171",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0169",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0157",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0155",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0151",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0150",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014F",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0133",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0122",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0120",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0119",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0117",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0115",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0113",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0108",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0106",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0105",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0103",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0102",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0101",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0100",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEE",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xED",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEC",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "i",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u203A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xBB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ";",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u203A",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xBB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ";",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ":",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "-",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201D",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2019",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "q",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "g",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "d",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "'",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\"",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "g",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "d",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "-",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u201D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u2019",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "j",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "'",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\"",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u201D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u2019",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "aogonek.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "abreve.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "amacron.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "aring.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "adieresis.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "atilde.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "acircumflex.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "aacute.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "agrave.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "a.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0153",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0151",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u014F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u014D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u011B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0119",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0117",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0115",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0113",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u010D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u010B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0109",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0107",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0105",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0103",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0101",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF8",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xEB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xEA",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE8",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "o",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "e",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "c",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "a",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0109",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "q",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "g",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "d",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "q",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "g",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "d",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0138",
    u2: "q",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0138",
    u2: "g",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0138",
    u2: "d",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u201D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "'",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\"",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "-",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "-",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "-",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "\u201D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "\u2019",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "j",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "'",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "\"",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "\u201D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "\u2019",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "j",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "'",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "\"",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "\u201D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "\u2019",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "j",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "'",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "\"",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "\u201D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "\u2019",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "j",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "'",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "\"",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u201E",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u201A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xBB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "v",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ";",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ":",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ".",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "-",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ",",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u201E",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u201A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xBB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "v",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ";",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ":",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ".",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "-",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ",",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201E",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ".",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ",",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\u203A",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xBB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ";",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ":",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ".",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "-",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0177",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0177",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ".",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "-",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\u203A",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xBB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ";",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ":",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\u203A",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xBB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ";",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ":",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ".",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "-",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF3",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF3",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "aogonek.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "abreve.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "amacron.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "aring.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "adieresis.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "atilde.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "acircumflex.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "aacute.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "agrave.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "a.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0161",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u015F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u015D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u015B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0153",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0151",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u014F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u014D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u011B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0119",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0117",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0115",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0113",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u010D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u010B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0109",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0107",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0102",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0100",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEA",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "s",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "o",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "e",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "c",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "q",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "g",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "d",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E83",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E82",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E81",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E80",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0175",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0174",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0166",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0164",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0162",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "w",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "W",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "T",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "aogonek.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "abreve.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "amacron.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "aring.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "adieresis.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "atilde.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "acircumflex.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "aacute.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "agrave.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "a.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0161",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u015F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u015D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u015B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0153",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0151",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u014F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u014D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u011B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0119",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0117",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0115",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0113",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u010D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u010B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0109",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0107",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0102",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0100",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEA",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "s",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "o",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "e",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "c",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "q",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "g",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "d",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E83",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E82",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E81",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E80",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0175",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0174",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0166",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0164",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0162",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "w",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "W",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "T",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u1E82",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u1E80",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0174",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0164",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0162",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0104",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0102",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0100",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "W",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "\u201D",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "\u2019",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "q",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "g",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "d",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "'",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "\"",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "agrave.alt",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aacute.alt",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "acircumflex.alt",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "atilde.alt",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "adieresis.alt",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aring.alt",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "amacron.alt",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "abreve.alt",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aogonek.alt",
    u2: "j",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum_pnum",
    u2: ".",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum_pnum",
    u2: ",",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.onum_pnum",
    u2: ".",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.onum_pnum",
    u2: ",",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "W,Wcircumflex,Wgrave,Wacute",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "Y,Ycircumflex,Ydieresis,Ygrave",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "W,Wcircumflex,Wgrave,Wacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "Y,Ycircumflex,Ydieresis,Ygrave",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "Y,Ycircumflex,Ydieresis,Ygrave",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "r,racute,rcedilla,rcaron",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "r,racute,rcedilla,rcaron",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,ij",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropaRegular);
export default __webpack_public_path__ + "static/media/Europa-Regular.dacc9fabeade21a0046490f719974f61.svg";
export { ForwardRef as ReactComponent };